var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "#100F3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.222 598.049V597.918C406.222 597.71 406.211 597.502 406.211 597.294C406.211 597.546 406.211 597.797 406.222 598.049Z",
    fill: "url(#paint0_linear_1962_309)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406.265 599.493V599.417C406.265 599.242 406.254 599.067 406.243 598.892C406.243 599.089 406.254 599.296 406.265 599.493Z",
    fill: "url(#paint1_linear_1962_309)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M406.461 602.545C406.461 602.49 406.45 602.436 406.45 602.381C406.428 602.217 406.417 602.053 406.406 601.889C406.417 602.108 406.439 602.326 406.461 602.545Z",
    fill: "url(#paint2_linear_1962_309)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M407.349 609.369C407.348 609.361 407.347 609.354 407.346 609.346C407.346 609.354 407.346 609.361 407.349 609.369ZM407.422 609.765C407.433 609.83 407.444 609.893 407.455 609.958C407.457 609.96 407.458 609.963 407.459 609.965C407.456 609.951 407.453 609.937 407.451 609.923C407.447 609.901 407.444 609.882 407.444 609.86C407.411 609.696 407.378 609.543 407.357 609.379C407.353 609.375 407.351 609.372 407.349 609.369C407.371 609.5 407.399 609.633 407.422 609.765Z",
    fill: "url(#paint3_linear_1962_309)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M407.483 610.096C407.477 610.06 407.472 610.025 407.466 609.989C407.466 609.984 407.462 609.978 407.461 609.973C407.469 610.014 407.476 610.055 407.483 610.096ZM407.576 610.602C407.541 610.43 407.512 610.264 407.483 610.096C407.511 610.268 407.54 610.439 407.576 610.602Z",
    fill: "url(#paint4_linear_1962_309)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M408.563 614.952C408.454 614.515 408.344 614.088 408.246 613.651C408.213 613.52 408.18 613.389 408.147 613.247C408.005 612.645 407.863 612.033 407.754 611.421C407.743 611.388 407.743 611.366 407.732 611.333C407.685 611.155 407.647 610.97 407.61 610.783C407.887 612.183 408.2 613.573 408.563 614.952Z",
    fill: "url(#paint5_linear_1962_309)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M410.772 622.017C410.691 621.798 410.61 621.58 410.53 621.36C410.609 621.58 410.689 621.799 410.772 622.017ZM411.307 623.404C411.197 623.12 411.088 622.825 410.979 622.53C410.906 622.36 410.837 622.189 410.772 622.017C410.945 622.482 411.121 622.943 411.307 623.404Z",
    fill: "url(#paint6_linear_1962_309)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M411.475 623.84C411.417 623.694 411.36 623.55 411.305 623.405C411.36 623.55 411.417 623.695 411.475 623.84ZM413.021 627.417C412.835 627.012 412.649 626.597 412.475 626.182C412.3 625.821 412.147 625.46 411.993 625.088C411.814 624.673 411.641 624.258 411.475 623.84C411.954 625.048 412.475 626.245 413.021 627.417Z",
    fill: "url(#paint7_linear_1962_309)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M413.328 628.075C413.334 628.086 413.34 628.097 413.346 628.108C413.309 628.029 413.275 627.948 413.24 627.867C413.164 627.714 413.098 627.572 413.021 627.419C413.12 627.638 413.218 627.856 413.328 628.075ZM413.417 628.256C413.393 628.207 413.37 628.156 413.346 628.108C413.368 628.158 413.392 628.207 413.417 628.256Z",
    fill: "url(#paint8_linear_1962_309)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M689.873 719.19C689.917 719.256 689.95 719.31 689.994 719.376C690.001 719.383 690.008 719.391 690.013 719.399C689.977 719.336 689.942 719.276 689.906 719.223C689.83 719.102 689.753 718.993 689.688 718.884C689.742 718.982 689.808 719.081 689.873 719.19ZM690.037 719.441C690.031 719.427 690.023 719.413 690.013 719.399C690.021 719.413 690.03 719.427 690.037 719.441Z",
    fill: "url(#paint9_linear_1962_309)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M691.992 722.23C692.023 722.272 692.054 722.302 692.085 722.343C692.054 722.302 692.024 722.272 692.003 722.23C691.981 722.208 691.97 722.187 691.948 722.165C691.959 722.187 691.981 722.208 691.992 722.23Z",
    fill: "url(#paint10_linear_1962_309)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M692.255 722.569C692.331 722.668 692.408 722.766 692.484 722.865C692.55 722.941 692.605 723.029 692.67 723.105C692.78 723.247 692.889 723.389 693.009 723.521C692.845 723.313 692.681 723.116 692.528 722.908C692.375 722.722 692.233 722.537 692.091 722.351C692.145 722.427 692.2 722.493 692.255 722.569Z",
    fill: "url(#paint11_linear_1962_309)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M694.082 724.811C694.082 724.811 694.093 724.822 694.104 724.833C693.972 724.68 693.841 724.527 693.71 724.374C693.83 724.516 693.95 724.658 694.082 724.811Z",
    fill: "url(#paint12_linear_1962_309)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M695.143 726.002C695.195 726.066 695.249 726.13 695.313 726.184C695.197 726.06 695.086 725.934 694.979 725.805C694.913 725.751 694.858 725.685 694.804 725.62C694.913 725.751 695.022 725.871 695.143 726.002ZM695.321 726.194C695.32 726.191 695.319 726.19 695.318 726.188C695.316 726.187 695.314 726.186 695.313 726.184C695.315 726.187 695.319 726.19 695.321 726.194ZM695.416 726.308C695.51 726.402 695.594 726.496 695.687 726.59C695.682 726.584 695.678 726.577 695.678 726.571C695.558 726.445 695.439 726.32 695.321 726.194C695.344 726.225 695.384 726.267 695.416 726.308Z",
    fill: "url(#paint13_linear_1962_309)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M699.189 730.003L699.178 729.981C699.101 729.915 699.025 729.85 698.959 729.784C699.036 729.861 699.112 729.926 699.189 730.003Z",
    fill: "url(#paint14_linear_1962_309)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M705.034 734.583C705.01 734.565 704.985 734.548 704.96 734.53C704.984 734.547 705.007 734.568 705.034 734.583ZM705.288 734.76C705.365 734.804 705.441 734.858 705.529 734.913C705.375 734.804 705.222 734.705 705.069 734.596C705.057 734.593 705.045 734.588 705.034 734.583C705.12 734.642 705.204 734.701 705.288 734.76Z",
    fill: "url(#paint15_linear_1962_309)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M709.415 737.318C709.409 737.313 709.404 737.31 709.398 737.307C709.405 737.313 709.41 737.315 709.415 737.318ZM710.175 737.744C710.337 737.836 710.499 737.918 710.671 738.008C710.248 737.785 709.834 737.551 709.42 737.318C709.42 737.318 709.418 737.318 709.415 737.318C709.661 737.466 709.918 737.605 710.175 737.744ZM710.71 738.028C710.697 738.022 710.684 738.014 710.671 738.008C710.684 738.015 710.697 738.022 710.71 738.028Z",
    fill: "url(#paint16_linear_1962_309)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M714.186 739.756C713.942 739.642 713.699 739.526 713.456 739.416C713.699 739.534 713.942 739.648 714.186 739.756ZM714.615 739.952C714.692 739.984 714.757 740.017 714.823 740.039C714.954 740.094 715.074 740.148 715.205 740.203C715.009 740.116 714.812 740.028 714.615 739.941C714.471 739.881 714.329 739.819 714.186 739.756C714.329 739.822 714.471 739.887 714.615 739.952Z",
    fill: "url(#paint17_linear_1962_309)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M715.795 740.466C716.035 740.564 716.287 740.663 716.527 740.772C716.888 740.914 717.249 741.056 717.62 741.209C717.664 741.22 717.708 741.231 717.741 741.253C717.905 741.319 718.08 741.384 718.255 741.45C718.429 741.505 718.604 741.57 718.779 741.636C718.604 741.57 718.429 741.505 718.255 741.439C717.828 741.286 717.413 741.122 717.008 740.958C716.604 740.794 716.199 740.63 715.795 740.455C715.61 740.384 715.426 740.302 715.241 740.22C715.426 740.302 715.61 740.384 715.795 740.466Z",
    fill: "url(#paint18_linear_1962_309)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M722.489 742.887C722.455 742.875 722.421 742.863 722.388 742.851C721.864 742.698 721.35 742.534 720.836 742.359C721.382 742.547 721.927 742.718 722.489 742.887ZM722.662 742.938C722.604 742.921 722.547 742.905 722.489 742.887C722.547 742.907 722.607 742.925 722.662 742.938Z",
    fill: "url(#paint19_linear_1962_309)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M732.512 745.166C732.527 745.166 732.542 745.171 732.558 745.175C732.553 745.173 732.549 745.17 732.545 745.166H732.512ZM732.577 745.177C732.571 745.177 732.564 745.176 732.558 745.175C732.564 745.177 732.571 745.177 732.577 745.177Z",
    fill: "url(#paint20_linear_1962_309)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M732.617 745.184C732.603 745.178 732.593 745.178 732.576 745.178C732.589 745.181 732.603 745.182 732.617 745.184ZM732.631 745.189C733.538 745.332 734.468 745.452 735.408 745.561C736.228 745.67 737.07 745.758 737.923 745.834C738.483 745.888 739.053 745.939 739.624 745.973C739.615 745.972 739.606 745.97 739.595 745.966C739.562 745.966 739.519 745.966 739.486 745.955C739.431 745.944 739.377 745.933 739.322 745.922C739.18 745.9 739.038 745.889 738.896 745.867C738.841 745.856 738.786 745.856 738.732 745.845C738.71 745.845 738.677 745.845 738.644 745.834C738.283 745.791 737.922 745.747 737.562 745.725C736.698 745.605 735.791 745.627 734.949 745.452C734.347 745.386 733.746 745.321 733.145 745.244C732.972 745.223 732.79 745.204 732.617 745.184C732.621 745.185 732.625 745.187 732.631 745.189ZM739.683 745.977C739.663 745.975 739.643 745.974 739.624 745.973C739.642 745.977 739.66 745.977 739.683 745.977Z",
    fill: "url(#paint21_linear_1962_309)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M740.121 746.035C740.107 746.033 740.091 746.031 740.076 746.03C740.091 746.032 740.107 746.033 740.121 746.035ZM740.382 746.073C740.414 746.073 740.455 746.083 740.487 746.084C740.441 746.079 740.395 746.072 740.35 746.062C740.268 746.052 740.194 746.044 740.121 746.035C740.207 746.047 740.299 746.065 740.382 746.073ZM740.503 746.086C740.498 746.085 740.495 746.085 740.492 746.084C740.491 746.084 740.489 746.084 740.487 746.084C740.493 746.085 740.497 746.085 740.503 746.086ZM740.94 746.128C740.852 746.117 740.765 746.117 740.678 746.095C740.62 746.095 740.561 746.092 740.503 746.086C740.641 746.106 740.791 746.117 740.94 746.128Z",
    fill: "url(#paint22_linear_1962_309)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M742.301 746.203C742.328 746.203 742.374 746.176 742.42 746.176C742.512 746.176 742.595 746.203 742.695 746.203H746.202C743.977 746.203 741.826 746.131 739.756 745.984C740.589 746.103 741.422 746.203 742.301 746.203Z",
    fill: "url(#paint23_linear_1962_309)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M739.757 745.985C739.023 745.885 738.3 745.783 737.559 745.73C736.699 745.61 735.792 745.628 734.949 745.454C734.172 745.381 733.402 745.289 732.634 745.188C734.904 745.545 737.275 745.81 739.757 745.985Z",
    fill: "url(#paint24_linear_1962_309)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M499.92 413.422L499.833 413.947L499.931 413.422C500.019 412.93 500.117 412.449 500.216 411.968C500.106 412.449 500.019 412.93 499.92 413.422Z",
    fill: "url(#paint25_linear_1962_309)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M503.112 401.886C502.992 402.258 502.85 402.651 502.718 403.034C502.095 404.805 501.538 406.598 501.057 408.424C501.549 406.598 502.095 404.805 502.729 403.034C502.861 402.651 502.992 402.258 503.123 401.886C503.156 401.798 503.189 401.711 503.221 401.612C503.189 401.711 503.156 401.798 503.112 401.886Z",
    fill: "url(#paint26_linear_1962_309)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M504.522 398.367C504.292 398.914 504.063 399.482 503.833 400.04C504.063 399.482 504.303 398.914 504.533 398.367C504.773 397.832 505.003 397.296 505.232 396.771C505.003 397.296 504.762 397.832 504.522 398.367Z",
    fill: "url(#paint27_linear_1962_309)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M509.53 388.744C509.858 388.208 510.175 387.695 510.525 387.181C510.164 387.695 509.858 388.208 509.53 388.744Z",
    fill: "url(#paint28_linear_1962_309)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M514.843 381.203C514.69 381.4 514.537 381.597 514.373 381.805C514.537 381.597 514.69 381.4 514.854 381.203C515.171 380.81 515.499 380.416 515.816 380.023C515.488 380.416 515.171 380.81 514.843 381.203Z",
    fill: "url(#paint29_linear_1962_309)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M516.799 378.873C516.46 379.255 516.132 379.638 515.815 380.021C516.143 379.638 516.482 379.255 516.81 378.873C516.952 378.709 517.095 378.534 517.248 378.37C517.084 378.534 516.952 378.709 516.799 378.873Z",
    fill: "url(#paint30_linear_1962_309)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M524.344 371.382C524.715 371.065 525.087 370.759 525.47 370.442C525.732 370.212 526.006 369.993 526.268 369.786C525.612 370.299 524.978 370.835 524.344 371.382Z",
    fill: "url(#paint31_linear_1962_309)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M498.605 670.603H522.101C516.383 669.979 509.517 667.17 505.417 663.824C501.022 660.249 498.605 652.552 498.605 643.029V670.603Z",
    fill: "url(#paint32_linear_1962_309)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M406.222 598.049V597.918C406.222 597.71 406.211 597.502 406.211 597.294C406.211 597.546 406.211 597.797 406.222 598.049Z",
    fill: "url(#paint33_linear_1962_309)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M406.265 599.493V599.417C406.265 599.242 406.254 599.067 406.243 598.892C406.243 599.089 406.254 599.296 406.265 599.493Z",
    fill: "url(#paint34_linear_1962_309)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M406.461 602.545C406.461 602.49 406.45 602.436 406.45 602.381C406.428 602.217 406.417 602.053 406.406 601.889C406.417 602.108 406.439 602.326 406.461 602.545Z",
    fill: "url(#paint35_linear_1962_309)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M407.349 609.369C407.348 609.361 407.347 609.354 407.346 609.346C407.346 609.354 407.346 609.361 407.349 609.369ZM407.422 609.765C407.433 609.83 407.444 609.893 407.455 609.958C407.457 609.96 407.458 609.963 407.459 609.965C407.456 609.951 407.453 609.937 407.451 609.923C407.447 609.901 407.444 609.882 407.444 609.86C407.411 609.696 407.378 609.543 407.357 609.379C407.353 609.375 407.351 609.372 407.349 609.369C407.371 609.5 407.399 609.633 407.422 609.765Z",
    fill: "url(#paint36_linear_1962_309)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M407.483 610.096C407.477 610.06 407.472 610.025 407.466 609.989C407.466 609.984 407.462 609.978 407.461 609.973C407.469 610.014 407.476 610.055 407.483 610.096ZM407.576 610.602C407.541 610.43 407.512 610.264 407.483 610.096C407.511 610.268 407.54 610.439 407.576 610.602Z",
    fill: "url(#paint37_linear_1962_309)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M408.563 614.952C408.454 614.515 408.344 614.088 408.246 613.651C408.213 613.52 408.18 613.389 408.147 613.247C408.005 612.645 407.863 612.033 407.754 611.421C407.743 611.388 407.743 611.366 407.732 611.333C407.685 611.155 407.647 610.97 407.61 610.783C407.887 612.183 408.2 613.573 408.563 614.952Z",
    fill: "url(#paint38_linear_1962_309)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M410.772 622.017C410.691 621.798 410.61 621.58 410.53 621.36C410.609 621.58 410.689 621.799 410.772 622.017ZM411.307 623.404C411.197 623.12 411.088 622.825 410.979 622.53C410.906 622.36 410.837 622.189 410.772 622.017C410.945 622.482 411.121 622.943 411.307 623.404Z",
    fill: "url(#paint39_linear_1962_309)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M411.475 623.84C411.417 623.694 411.36 623.55 411.305 623.405C411.36 623.55 411.417 623.695 411.475 623.84ZM413.021 627.417C412.835 627.012 412.649 626.597 412.475 626.182C412.3 625.821 412.147 625.46 411.993 625.088C411.814 624.673 411.641 624.258 411.475 623.84C411.954 625.048 412.475 626.245 413.021 627.417Z",
    fill: "url(#paint40_linear_1962_309)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M413.328 628.075C413.334 628.086 413.34 628.097 413.346 628.108C413.309 628.029 413.275 627.948 413.24 627.867C413.164 627.714 413.098 627.572 413.021 627.419C413.12 627.638 413.218 627.856 413.328 628.075ZM413.417 628.256C413.393 628.207 413.37 628.156 413.346 628.108C413.368 628.158 413.392 628.207 413.417 628.256Z",
    fill: "url(#paint41_linear_1962_309)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M689.873 719.19C689.917 719.256 689.95 719.31 689.994 719.376C690.001 719.383 690.008 719.391 690.013 719.399C689.977 719.336 689.942 719.276 689.906 719.223C689.83 719.102 689.753 718.993 689.688 718.884C689.742 718.982 689.808 719.081 689.873 719.19ZM690.037 719.441C690.031 719.427 690.023 719.413 690.013 719.399C690.021 719.413 690.03 719.427 690.037 719.441Z",
    fill: "url(#paint42_linear_1962_309)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M691.992 722.23C692.023 722.272 692.054 722.302 692.085 722.343C692.054 722.302 692.024 722.272 692.003 722.23C691.981 722.208 691.97 722.187 691.948 722.165C691.959 722.187 691.981 722.208 691.992 722.23Z",
    fill: "url(#paint43_linear_1962_309)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M692.255 722.569C692.331 722.668 692.408 722.766 692.484 722.865C692.55 722.941 692.605 723.029 692.67 723.105C692.78 723.247 692.889 723.389 693.009 723.521C692.845 723.313 692.681 723.116 692.528 722.908C692.375 722.722 692.233 722.537 692.091 722.351C692.145 722.427 692.2 722.493 692.255 722.569Z",
    fill: "url(#paint44_linear_1962_309)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M694.082 724.811C694.082 724.811 694.093 724.822 694.104 724.833C693.972 724.68 693.841 724.527 693.71 724.374C693.83 724.516 693.95 724.658 694.082 724.811Z",
    fill: "url(#paint45_linear_1962_309)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M695.143 726.002C695.195 726.066 695.249 726.13 695.313 726.184C695.197 726.06 695.086 725.934 694.979 725.805C694.913 725.751 694.858 725.685 694.804 725.62C694.913 725.751 695.022 725.871 695.143 726.002ZM695.321 726.194C695.32 726.191 695.319 726.19 695.318 726.188C695.316 726.187 695.314 726.186 695.313 726.184C695.315 726.187 695.319 726.19 695.321 726.194ZM695.416 726.308C695.51 726.402 695.594 726.496 695.687 726.59C695.682 726.584 695.678 726.577 695.678 726.571C695.558 726.445 695.439 726.32 695.321 726.194C695.344 726.225 695.384 726.267 695.416 726.308Z",
    fill: "url(#paint46_linear_1962_309)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M699.189 730.003L699.178 729.981C699.101 729.915 699.025 729.85 698.959 729.784C699.036 729.861 699.112 729.926 699.189 730.003Z",
    fill: "url(#paint47_linear_1962_309)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M705.034 734.583C705.01 734.565 704.985 734.548 704.96 734.53C704.984 734.547 705.007 734.568 705.034 734.583ZM705.288 734.76C705.365 734.804 705.441 734.858 705.529 734.913C705.375 734.804 705.222 734.705 705.069 734.596C705.057 734.593 705.045 734.588 705.034 734.583C705.12 734.642 705.204 734.701 705.288 734.76Z",
    fill: "url(#paint48_linear_1962_309)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M709.415 737.318C709.409 737.313 709.404 737.31 709.398 737.307C709.405 737.313 709.41 737.315 709.415 737.318ZM710.175 737.744C710.337 737.836 710.499 737.918 710.671 738.008C710.248 737.785 709.834 737.551 709.42 737.318C709.42 737.318 709.418 737.318 709.415 737.318C709.661 737.466 709.918 737.605 710.175 737.744ZM710.71 738.028C710.697 738.022 710.684 738.014 710.671 738.008C710.684 738.015 710.697 738.022 710.71 738.028Z",
    fill: "url(#paint49_linear_1962_309)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M714.186 739.756C713.942 739.642 713.699 739.526 713.456 739.416C713.699 739.534 713.942 739.648 714.186 739.756ZM714.615 739.952C714.692 739.984 714.757 740.017 714.823 740.039C714.954 740.094 715.074 740.148 715.205 740.203C715.009 740.116 714.812 740.028 714.615 739.941C714.471 739.881 714.329 739.819 714.186 739.756C714.329 739.822 714.471 739.887 714.615 739.952Z",
    fill: "url(#paint50_linear_1962_309)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M715.795 740.466C716.035 740.564 716.287 740.663 716.527 740.772C716.888 740.914 717.249 741.056 717.62 741.209C717.664 741.22 717.708 741.231 717.741 741.253C717.905 741.319 718.08 741.384 718.255 741.45C718.429 741.505 718.604 741.57 718.779 741.636C718.604 741.57 718.429 741.505 718.255 741.439C717.828 741.286 717.413 741.122 717.008 740.958C716.604 740.794 716.199 740.63 715.795 740.455C715.61 740.384 715.426 740.302 715.241 740.22C715.426 740.302 715.61 740.384 715.795 740.466Z",
    fill: "url(#paint51_linear_1962_309)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M722.489 742.887C722.455 742.875 722.421 742.863 722.388 742.851C721.864 742.698 721.35 742.534 720.836 742.359C721.382 742.547 721.927 742.718 722.489 742.887ZM722.662 742.938C722.604 742.921 722.547 742.905 722.489 742.887C722.547 742.907 722.607 742.925 722.662 742.938Z",
    fill: "url(#paint52_linear_1962_309)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M732.512 745.166C732.527 745.166 732.542 745.171 732.558 745.175C732.553 745.173 732.549 745.17 732.545 745.166H732.512ZM732.577 745.177C732.571 745.177 732.564 745.176 732.558 745.175C732.564 745.177 732.571 745.177 732.577 745.177Z",
    fill: "url(#paint53_linear_1962_309)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M732.617 745.184C732.603 745.178 732.593 745.178 732.576 745.178C732.589 745.181 732.603 745.182 732.617 745.184ZM732.631 745.189C733.538 745.332 734.468 745.452 735.408 745.561C736.228 745.67 737.07 745.758 737.923 745.834C738.483 745.888 739.053 745.939 739.624 745.973C739.615 745.972 739.606 745.97 739.595 745.966C739.562 745.966 739.519 745.966 739.486 745.955C739.431 745.944 739.377 745.933 739.322 745.922C739.18 745.9 739.038 745.889 738.896 745.867C738.841 745.856 738.786 745.856 738.732 745.845C738.71 745.845 738.677 745.845 738.644 745.834C738.283 745.791 737.922 745.747 737.562 745.725C736.698 745.605 735.791 745.627 734.949 745.452C734.347 745.386 733.746 745.321 733.145 745.244C732.972 745.223 732.79 745.204 732.617 745.184C732.621 745.185 732.625 745.187 732.631 745.189ZM739.683 745.977C739.663 745.975 739.643 745.974 739.624 745.973C739.642 745.977 739.66 745.977 739.683 745.977Z",
    fill: "url(#paint54_linear_1962_309)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M740.121 746.035C740.107 746.033 740.091 746.031 740.076 746.03C740.091 746.032 740.107 746.033 740.121 746.035ZM740.382 746.073C740.414 746.073 740.455 746.083 740.487 746.084C740.441 746.079 740.395 746.072 740.35 746.062C740.268 746.052 740.194 746.044 740.121 746.035C740.207 746.047 740.299 746.065 740.382 746.073ZM740.503 746.086C740.498 746.085 740.495 746.085 740.492 746.084C740.491 746.084 740.489 746.084 740.487 746.084C740.493 746.085 740.497 746.085 740.503 746.086ZM740.94 746.128C740.852 746.117 740.765 746.117 740.678 746.095C740.62 746.095 740.561 746.092 740.503 746.086C740.641 746.106 740.791 746.117 740.94 746.128Z",
    fill: "url(#paint55_linear_1962_309)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M740.077 746.033C740.175 746.044 740.285 746.066 740.383 746.077C740.416 746.077 740.459 746.088 740.492 746.088C740.634 746.11 740.788 746.121 740.941 746.131C740.984 746.142 741.039 746.142 741.094 746.153C741.487 746.186 741.892 746.208 742.307 746.208C742.329 746.208 742.373 746.175 742.417 746.175C742.515 746.175 742.591 746.208 742.701 746.208H745.62C743.597 746.197 741.64 746.121 739.76 745.989C739.869 746 739.967 746.022 740.077 746.033Z",
    fill: "url(#paint56_linear_1962_309)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M735.41 745.561C736.23 745.67 737.072 745.758 737.925 745.834C738.485 745.888 739.055 745.939 739.626 745.973C739.617 745.972 739.608 745.97 739.597 745.966C739.564 745.966 739.521 745.966 739.488 745.955C739.433 745.944 739.379 745.933 739.324 745.922C739.182 745.9 739.04 745.889 738.898 745.867C738.843 745.856 738.788 745.856 738.734 745.845C738.712 745.845 738.679 745.845 738.646 745.834C738.285 745.791 737.924 745.747 737.564 745.725C736.7 745.605 735.792 745.627 734.951 745.452C734.349 745.397 733.748 745.321 733.147 745.244C732.972 745.233 732.808 745.211 732.633 745.189C733.54 745.332 734.47 745.452 735.41 745.561ZM739.685 745.977C739.665 745.975 739.645 745.974 739.626 745.973C739.644 745.977 739.662 745.977 739.685 745.977Z",
    fill: "url(#paint57_linear_1962_309)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M498.605 448.703V468.514C499.535 464.96 501.186 461.691 503.383 458.892C508.249 452.682 515.814 448.703 524.342 448.703H498.605Z",
    fill: "url(#paint58_linear_1962_309)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M406.222 598.049V597.918C406.222 597.71 406.211 597.502 406.211 597.294C406.211 597.546 406.211 597.797 406.222 598.049Z",
    fill: "url(#paint59_linear_1962_309)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M406.265 599.493V599.417C406.265 599.242 406.254 599.067 406.243 598.892C406.243 599.089 406.254 599.296 406.265 599.493Z",
    fill: "url(#paint60_linear_1962_309)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M406.461 602.545C406.461 602.49 406.45 602.436 406.45 602.381C406.428 602.217 406.417 602.053 406.406 601.889C406.417 602.108 406.439 602.326 406.461 602.545Z",
    fill: "url(#paint61_linear_1962_309)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M407.349 609.369C407.348 609.361 407.347 609.354 407.346 609.346C407.346 609.354 407.346 609.361 407.349 609.369ZM407.422 609.765C407.433 609.83 407.444 609.893 407.455 609.958C407.457 609.96 407.458 609.963 407.459 609.965C407.456 609.951 407.453 609.937 407.451 609.923C407.447 609.901 407.444 609.882 407.444 609.86C407.411 609.696 407.378 609.543 407.357 609.379C407.353 609.375 407.351 609.372 407.349 609.369C407.371 609.5 407.399 609.633 407.422 609.765Z",
    fill: "url(#paint62_linear_1962_309)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M407.487 610.122C407.481 610.078 407.473 610.034 407.466 609.989C407.466 609.984 407.462 609.978 407.461 609.973C407.471 610.022 407.48 610.072 407.487 610.122ZM407.547 610.459C407.545 610.439 407.543 610.417 407.543 610.394C407.524 610.321 407.51 610.247 407.497 610.173C407.513 610.268 407.53 610.363 407.547 610.459ZM407.564 610.541C407.558 610.514 407.553 610.487 407.547 610.459C407.552 610.488 407.557 610.515 407.564 610.541ZM407.576 610.602C407.572 610.582 407.568 610.562 407.564 610.541C407.567 610.562 407.571 610.582 407.576 610.602Z",
    fill: "url(#paint63_linear_1962_309)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M407.588 610.689C407.872 612.121 408.189 613.543 408.561 614.953C408.572 614.997 408.583 615.052 408.605 615.117C408.485 614.636 408.364 614.144 408.244 613.652C408.211 613.521 408.178 613.39 408.146 613.248C408.124 613.127 408.091 613.007 408.069 612.876C407.96 612.395 407.85 611.914 407.752 611.422C407.741 611.389 407.741 611.367 407.73 611.334C407.708 611.258 407.697 611.181 407.686 611.094C407.643 610.963 407.621 610.831 407.599 610.689C407.588 610.667 407.577 610.635 407.577 610.602C407.577 610.635 407.588 610.667 407.588 610.689Z",
    fill: "url(#paint64_linear_1962_309)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M409.818 619.282C410.026 619.894 410.234 620.518 410.452 621.13C410.234 620.496 410.015 619.851 409.807 619.217C409.796 619.184 409.785 619.151 409.774 619.118C409.785 619.173 409.807 619.228 409.818 619.282Z",
    fill: "url(#paint65_linear_1962_309)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M410.531 621.36C410.782 622.049 411.034 622.726 411.307 623.404C411.198 623.12 411.088 622.825 410.979 622.53C410.793 622.07 410.629 621.6 410.454 621.13C410.476 621.207 410.509 621.283 410.531 621.36Z",
    fill: "url(#paint66_linear_1962_309)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M411.475 623.84C411.417 623.694 411.36 623.55 411.305 623.405C411.36 623.55 411.417 623.695 411.475 623.84ZM413.021 627.417C412.835 627.012 412.649 626.597 412.475 626.182C412.3 625.821 412.147 625.46 411.993 625.088C411.814 624.673 411.641 624.258 411.475 623.84C411.954 625.048 412.475 626.245 413.021 627.417Z",
    fill: "url(#paint67_linear_1962_309)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M413.328 628.071C413.295 628.006 413.262 627.929 413.24 627.864C413.164 627.711 413.098 627.568 413.021 627.415C413.12 627.634 413.218 627.853 413.328 628.071Z",
    fill: "url(#paint68_linear_1962_309)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M414.848 631.089C414.946 631.264 415.033 631.439 415.132 631.603C414.946 631.264 414.76 630.914 414.574 630.564C414.662 630.739 414.76 630.914 414.848 631.089Z",
    fill: "url(#paint69_linear_1962_309)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M688.122 716.162C688.133 716.172 688.133 716.183 688.144 716.194C688.144 716.183 688.133 716.172 688.133 716.162H688.122Z",
    fill: "url(#paint70_linear_1962_309)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M689.873 719.189C689.917 719.255 689.95 719.309 689.994 719.375C689.972 719.32 689.939 719.266 689.906 719.222C689.83 719.102 689.753 718.992 689.688 718.883C689.742 718.981 689.808 719.08 689.873 719.189Z",
    fill: "url(#paint71_linear_1962_309)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M691.992 722.23C692.023 722.272 692.055 722.302 692.085 722.343C692.055 722.302 692.024 722.272 692.003 722.23H691.992Z",
    fill: "url(#paint72_linear_1962_309)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M692.672 723.105C692.782 723.247 692.891 723.389 693.011 723.521C692.847 723.313 692.683 723.116 692.53 722.908C692.519 722.897 692.508 722.875 692.486 722.865C692.552 722.941 692.607 723.029 692.672 723.105Z",
    fill: "url(#paint73_linear_1962_309)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M695.143 726.003C695.088 725.937 695.022 725.872 694.979 725.806C694.913 725.751 694.858 725.686 694.804 725.62C694.913 725.751 695.022 725.872 695.143 726.003Z",
    fill: "url(#paint74_linear_1962_309)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M695.414 726.308C695.508 726.402 695.592 726.496 695.685 726.59C695.68 726.584 695.676 726.577 695.676 726.571C695.545 726.44 695.425 726.319 695.315 726.188C695.337 726.221 695.381 726.265 695.414 726.308Z",
    fill: "url(#paint75_linear_1962_309)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M699.189 730.001C699.209 730.016 699.229 730.032 699.249 730.048C699.226 730.027 699.202 730.004 699.178 729.98C699.101 729.914 699.025 729.848 698.959 729.783C699.036 729.859 699.112 729.925 699.189 730.001ZM699.407 730.198C699.352 730.142 699.301 730.093 699.249 730.048C699.302 730.099 699.354 730.146 699.407 730.198Z",
    fill: "url(#paint76_linear_1962_309)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M704.477 734.194C704.184 733.985 703.894 733.783 703.608 733.574C703.895 733.784 704.184 733.99 704.477 734.194ZM704.566 734.257C704.697 734.355 704.828 734.443 704.96 734.53C705.069 734.607 705.178 734.683 705.288 734.76C705.364 734.804 705.441 734.858 705.528 734.913C705.375 734.804 705.222 734.705 705.069 734.596C704.87 734.464 704.673 734.329 704.477 734.194C704.507 734.216 704.536 734.236 704.566 734.257Z",
    fill: "url(#paint77_linear_1962_309)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M714.186 739.755C713.942 739.641 713.699 739.525 713.456 739.415C713.699 739.533 713.942 739.647 714.186 739.755ZM714.615 739.951C714.692 739.983 714.757 740.016 714.823 740.038C714.757 740.005 714.681 739.972 714.615 739.94C714.471 739.88 714.329 739.818 714.186 739.755C714.329 739.821 714.471 739.886 714.615 739.951Z",
    fill: "url(#paint78_linear_1962_309)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M715.795 740.466C716.035 740.564 716.287 740.663 716.527 740.772C716.888 740.914 717.249 741.056 717.62 741.209C717.664 741.22 717.708 741.231 717.741 741.253C717.905 741.319 718.08 741.384 718.255 741.45C718.429 741.505 718.604 741.57 718.779 741.636C718.604 741.57 718.429 741.505 718.255 741.439C717.828 741.286 717.413 741.122 717.008 740.958C716.604 740.794 716.199 740.63 715.795 740.455C715.61 740.384 715.426 740.302 715.241 740.22C715.426 740.302 715.61 740.384 715.795 740.466Z",
    fill: "url(#paint79_linear_1962_309)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M722.489 742.887C722.455 742.875 722.421 742.863 722.388 742.851C721.864 742.698 721.35 742.534 720.836 742.359C721.382 742.547 721.927 742.718 722.489 742.887ZM722.662 742.938C722.604 742.921 722.547 742.905 722.489 742.887C722.547 742.907 722.607 742.925 722.662 742.938Z",
    fill: "url(#paint80_linear_1962_309)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M732.512 745.166C732.527 745.166 732.542 745.171 732.558 745.175C732.553 745.173 732.549 745.17 732.545 745.166H732.512ZM732.577 745.177C732.571 745.177 732.564 745.176 732.558 745.175C732.564 745.177 732.571 745.177 732.577 745.177Z",
    fill: "url(#paint81_linear_1962_309)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M739.624 745.973C739.615 745.972 739.607 745.97 739.596 745.966C739.563 745.966 739.519 745.966 739.486 745.955C738.961 745.922 738.437 745.878 737.923 745.834C738.484 745.888 739.053 745.939 739.624 745.973ZM739.683 745.977C739.663 745.975 739.644 745.974 739.624 745.973C739.643 745.977 739.66 745.977 739.683 745.977Z",
    fill: "url(#paint82_linear_1962_309)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M740.121 746.035C740.107 746.033 740.091 746.03 740.076 746.029C740.091 746.032 740.107 746.033 740.121 746.035ZM740.382 746.073C740.415 746.073 740.459 746.084 740.492 746.084C740.437 746.073 740.393 746.073 740.35 746.062C740.268 746.052 740.194 746.044 740.121 746.035C740.207 746.047 740.299 746.064 740.382 746.073Z",
    fill: "url(#paint83_linear_1962_309)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M740.942 746.128C740.855 746.117 740.768 746.117 740.68 746.095C740.614 746.095 740.549 746.084 740.494 746.084C740.636 746.106 740.789 746.117 740.942 746.128Z",
    fill: "url(#paint84_linear_1962_309)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M696.421 727.347C695.655 726.57 694.956 725.805 694.311 725.062C694.945 725.805 695.644 726.57 696.421 727.347Z",
    fill: "url(#paint85_linear_1962_309)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M732.631 745.189C734.884 745.539 737.223 745.802 739.683 745.977C739.388 745.933 739.093 745.889 738.798 745.856C738.754 745.845 738.699 745.845 738.645 745.834C738.284 745.791 737.923 745.747 737.562 745.725C736.699 745.605 735.791 745.627 734.949 745.452C734.348 745.386 733.747 745.321 733.145 745.244C732.948 745.222 732.741 745.2 732.544 745.168C732.577 745.178 732.599 745.178 732.631 745.189Z",
    fill: "url(#paint86_linear_1962_309)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M740.941 746.131C740.984 746.142 741.039 746.142 741.094 746.153C741.487 746.186 741.892 746.208 742.307 746.208C742.329 746.208 742.373 746.175 742.417 746.175C742.515 746.175 742.591 746.208 742.701 746.208H745.62C743.597 746.197 741.64 746.121 739.76 745.989C740.142 746.044 740.547 746.099 740.941 746.131Z",
    fill: "url(#paint87_linear_1962_309)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M739.685 745.977C739.39 745.933 739.094 745.889 738.799 745.856C738.755 745.845 738.701 745.845 738.646 745.834C738.285 745.791 737.924 745.747 737.564 745.725C736.7 745.605 735.792 745.627 734.951 745.452C734.349 745.397 733.748 745.321 733.147 745.244C732.972 745.233 732.808 745.211 732.633 745.189C734.885 745.539 737.225 745.802 739.685 745.977Z",
    fill: "url(#paint88_linear_1962_309)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M388.718 527.97C388.445 528.145 388.171 528.341 387.909 528.538L346.778 558.9L336.064 566.804H336.053C336.053 566.804 336.042 566.826 336.031 566.87C336.02 566.881 336.02 566.892 336.009 566.903C336.009 566.936 335.987 566.968 335.954 567.023C335.943 567.034 335.932 567.056 335.932 567.078C335.922 567.1 335.911 567.132 335.889 567.165C335.878 567.176 335.878 567.176 335.878 567.187C335.867 567.198 335.856 567.209 335.856 567.22C335.834 567.253 335.823 567.285 335.801 567.318C335.779 567.362 335.758 567.406 335.725 567.46C335.725 567.482 335.714 567.504 335.703 567.515C335.659 567.603 335.604 567.701 335.55 567.81C335.539 567.821 335.539 567.832 335.539 567.843C335.506 567.887 335.473 567.952 335.44 568.007C335.43 568.018 335.43 568.029 335.43 568.04C335.397 568.084 335.364 568.127 335.342 568.182C335.32 568.215 335.298 568.248 335.276 568.291C335.222 568.39 335.156 568.499 335.091 568.619C334.959 568.86 334.795 569.122 334.62 569.417C334.566 569.527 334.5 569.625 334.424 569.735C334.391 569.789 334.358 569.844 334.314 569.909C334.26 570.008 334.194 570.106 334.129 570.216C334.107 570.248 334.085 570.281 334.074 570.314C334.052 570.347 334.03 570.369 334.008 570.401C333.986 570.423 333.975 570.445 333.965 570.467C333.932 570.522 333.888 570.587 333.855 570.642C333.822 570.697 333.779 570.74 333.746 570.795C333.658 570.915 333.582 571.046 333.494 571.167C333.473 571.2 333.451 571.232 333.429 571.276C333.309 571.451 333.188 571.626 333.057 571.812C332.827 572.14 332.576 572.479 332.314 572.829C332.215 572.971 332.117 573.113 332.007 573.255C331.843 573.463 331.679 573.681 331.515 573.889C331.45 573.966 331.395 574.053 331.33 574.13C331.297 574.173 331.253 574.228 331.22 574.272C331.144 574.37 331.067 574.458 330.991 574.545C330.761 574.829 330.531 575.114 330.291 575.398C330.171 575.54 330.039 575.693 329.919 575.835V575.846C329.919 575.846 329.908 575.846 329.897 575.857C329.832 575.934 329.755 576.01 329.69 576.087C329.427 576.393 329.143 576.71 328.859 577.027C328.782 577.114 328.717 577.191 328.64 577.267C328.618 577.289 328.607 577.311 328.585 577.333C328.487 577.431 328.4 577.53 328.301 577.628V577.639C328.29 577.639 328.29 577.639 328.279 577.65C328.236 577.694 328.192 577.749 328.148 577.792C327.962 577.989 327.776 578.175 327.58 578.372C327.383 578.569 327.186 578.776 326.978 578.973C326.88 579.082 326.792 579.17 326.694 579.257C326.169 579.771 325.622 580.296 325.043 580.81C324.977 580.875 324.901 580.941 324.835 581.018C324.824 581.018 324.824 581.018 324.813 581.028C324.737 581.083 324.671 581.149 324.595 581.225C324.573 581.236 324.54 581.258 324.518 581.291C324.464 581.335 324.409 581.378 324.354 581.433C324.212 581.553 324.07 581.674 323.928 581.794C323.829 581.881 323.731 581.969 323.633 582.045C323.141 582.461 322.638 582.876 322.124 583.281C321.599 583.696 321.041 584.123 320.473 584.538C320.134 584.79 319.784 585.041 319.434 585.281C319.347 585.347 319.259 585.413 319.172 585.467C319.128 585.5 319.084 585.522 319.041 585.555C319.019 585.566 318.997 585.588 318.975 585.609C318.888 585.664 318.8 585.719 318.713 585.784C318.636 585.828 318.56 585.883 318.472 585.937C318.166 586.145 317.849 586.353 317.532 586.561C317.412 586.637 317.302 586.703 317.182 586.79C316.694 587.106 316.174 587.409 315.661 587.715C315.326 587.921 314.98 588.126 314.624 588.321C314.339 588.485 314.055 588.638 313.771 588.802C313.421 588.988 313.06 589.185 312.689 589.371C312.35 589.545 312.012 589.719 311.663 589.894C311.45 589.999 311.243 590.111 311.027 590.212C310.807 590.322 310.57 590.423 310.346 590.531C310.289 590.556 310.234 590.585 310.174 590.606C309.911 590.737 309.649 590.857 309.387 590.978C309.31 591.01 309.245 591.043 309.179 591.065C309.048 591.12 308.928 591.174 308.796 591.229C308.6 591.317 308.403 591.404 308.206 591.492C307.965 591.59 307.714 591.688 307.473 591.798C307.309 591.863 307.156 591.918 306.992 591.984C306.796 592.071 306.588 592.148 306.38 592.235C306.336 592.246 306.293 592.257 306.26 592.279C306.249 592.29 306.227 592.29 306.216 592.301C306.063 592.355 305.91 592.421 305.746 592.476C305.582 592.53 305.418 592.585 305.254 592.65C305.112 592.705 304.97 592.76 304.817 592.814C304.27 593.011 303.723 593.197 303.166 593.383C302.564 593.591 301.952 593.777 301.34 593.962C300.717 594.148 300.094 594.334 299.448 594.498C299.35 594.52 299.263 594.553 299.164 594.586C299.055 594.608 298.946 594.64 298.836 594.662C298.628 594.717 298.421 594.772 298.213 594.826C298.071 594.859 297.918 594.903 297.765 594.935C297.699 594.957 297.634 594.968 297.557 594.99C297.196 595.089 296.835 595.176 296.464 595.242C296.179 595.307 295.895 595.373 295.611 595.427C295.458 595.46 295.294 595.504 295.13 595.526C295.021 595.548 294.911 595.581 294.802 595.602C294.758 595.602 294.725 595.613 294.693 595.624C294.682 595.624 294.671 595.624 294.66 595.635H294.605C294.518 595.657 294.43 595.679 294.343 595.69C294.19 595.734 294.047 595.755 293.894 595.777C293.862 595.799 293.818 595.799 293.774 595.799C293.719 595.81 293.665 595.821 293.61 595.832C293.577 595.832 293.555 595.843 293.523 595.854H293.512C293.468 595.854 293.424 595.865 293.381 595.876C292.779 595.985 292.167 596.083 291.555 596.182H291.533C291.522 596.182 291.5 596.182 291.489 596.193H291.456C291.445 596.193 291.434 596.204 291.423 596.204C291.402 596.204 291.391 596.204 291.369 596.215C291.259 596.237 291.15 596.247 291.03 596.258C290.691 596.313 290.341 596.368 289.991 596.411C289.149 596.543 288.286 596.641 287.411 596.729C286.974 596.772 286.525 596.816 286.077 596.86C285.695 596.893 285.301 596.936 284.907 596.958C284.787 596.969 284.667 596.98 284.547 596.98C284.525 596.991 284.503 596.991 284.481 596.991C284.448 597.002 284.404 597.002 284.361 597.002H284.317C284.306 597.013 284.295 597.013 284.284 597.013H284.229C284.12 597.024 284.033 597.046 283.923 597.057C283.825 597.067 283.716 597.089 283.617 597.1C283.584 597.1 283.541 597.111 283.508 597.111C283.366 597.133 283.213 597.144 283.06 597.155C283.038 597.155 283.016 597.166 282.994 597.166C282.972 597.166 282.939 597.166 282.907 597.177C282.524 597.21 282.119 597.231 281.715 597.231H281.693C281.682 597.231 281.66 597.221 281.649 597.221C281.627 597.21 281.605 597.199 281.584 597.199C281.54 597.199 281.496 597.21 281.452 597.221C281.409 597.221 281.354 597.231 281.299 597.231H278.38L277.801 598.992L266.868 632.229C266.212 634.229 265.763 636.252 265.534 638.286C265.462 638.918 265.413 639.548 265.382 640.178C265.364 640.506 265.361 640.833 265.353 641.161C265.35 641.358 265.337 641.555 265.337 641.751C265.337 641.871 265.345 641.991 265.347 642.111C265.359 643.21 265.433 644.301 265.565 645.383C265.581 645.513 265.592 645.644 265.61 645.775C265.621 645.906 265.643 646.048 265.665 646.179C265.698 646.42 265.741 646.66 265.774 646.901C266.276 649.822 267.221 652.652 268.564 655.299C268.58 655.327 268.591 655.357 268.606 655.385C268.629 655.431 268.655 655.474 268.679 655.518C268.899 655.944 269.13 656.364 269.37 656.778C269.382 656.798 269.392 656.82 269.404 656.839C269.502 657.014 269.601 657.189 269.71 657.364C269.994 657.834 270.29 658.293 270.607 658.742C270.727 658.916 270.836 659.08 270.967 659.255C271.11 659.452 271.252 659.649 271.394 659.835C271.536 660.032 271.678 660.228 271.842 660.414C271.962 660.567 272.094 660.731 272.225 660.884C272.4 661.114 272.586 661.333 272.782 661.54C272.935 661.726 273.099 661.901 273.263 662.076C274.04 662.918 274.871 663.727 275.756 664.481C276.073 664.755 276.401 665.017 276.729 665.28C276.926 665.444 277.123 665.597 277.32 665.739C277.516 665.892 277.713 666.045 277.921 666.187C279.452 667.302 281.059 668.264 282.743 669.073C283.573 669.467 284.426 669.828 285.29 670.156C285.301 670.156 285.301 670.167 285.301 670.167C287.313 670.899 289.401 671.424 291.478 671.719C292.167 671.829 292.856 671.894 293.534 671.949C294.222 672.004 294.911 672.025 295.589 672.025C296.059 672.025 296.54 672.014 297.01 671.993C297.71 671.96 298.421 671.894 299.12 671.818C299.514 671.774 299.897 671.719 300.29 671.654C301.46 671.457 302.619 671.205 303.767 670.877C304.128 670.779 304.478 670.67 304.828 670.549C304.871 670.538 304.915 670.528 304.97 670.506C305.33 670.385 305.691 670.265 306.041 670.134C306.424 669.992 306.796 669.839 307.167 669.686C307.67 669.478 308.173 669.248 308.665 669.008C308.982 668.855 309.288 668.691 309.594 668.538C309.66 668.494 309.726 668.461 309.791 668.428L309.802 668.417C310.119 668.253 310.425 668.079 310.731 667.893C310.753 667.882 310.775 667.871 310.797 667.86C310.906 667.794 311.016 667.729 311.136 667.652C311.956 667.16 312.776 666.613 313.563 666.023L389.921 609.652V527.15C389.516 527.412 389.111 527.675 388.718 527.97Z",
    fill: "url(#paint89_linear_1962_309)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M617.791 448.32C617.791 448.527 617.78 448.735 617.78 448.943V449.271C617.78 449.391 617.769 449.522 617.769 449.642C617.769 449.73 617.758 449.828 617.758 449.916C617.747 450.091 617.737 450.266 617.737 450.441V450.517C617.726 450.801 617.715 451.086 617.693 451.381C617.693 451.457 617.682 451.545 617.682 451.621C617.682 451.665 617.671 451.709 617.671 451.753C617.671 451.796 617.66 451.84 617.66 451.884C617.66 451.96 617.66 452.048 617.649 452.124C617.627 452.387 617.616 452.649 617.594 452.911C617.583 453.075 617.572 453.239 617.551 453.403C617.551 453.458 617.54 453.513 617.54 453.567C617.507 454.048 617.463 454.53 617.408 455.011C617.376 455.262 617.354 455.514 617.332 455.765C617.31 456.016 617.277 456.268 617.245 456.519C617.179 457.022 617.113 457.514 617.037 458.017C616.96 458.498 616.884 458.979 616.818 459.471C616.807 459.482 616.807 459.493 616.807 459.504C616.763 459.788 616.709 460.084 616.654 460.368C616.654 460.379 616.654 460.39 616.643 460.401C616.643 460.423 616.632 460.444 616.632 460.466C616.61 460.608 616.589 460.74 616.556 460.882C616.556 460.912 616.548 460.942 616.546 460.971C616.545 460.975 616.545 460.98 616.544 460.985C616.54 460.993 616.534 461.003 616.534 461.013C616.512 461.155 616.49 461.286 616.457 461.417C616.457 461.439 616.457 461.461 616.446 461.483C616.446 461.538 616.435 461.581 616.425 461.625C616.425 461.642 616.421 461.654 616.419 461.669C616.411 461.704 616.407 461.74 616.4 461.774C616.392 461.819 616.385 461.865 616.37 461.909V461.931C616.239 462.587 616.097 463.243 615.933 463.899C615.922 463.932 615.922 463.954 615.911 463.987C615.9 464.085 615.867 464.194 615.845 464.293C615.725 464.85 615.583 465.419 615.441 465.977C615.43 466.02 615.419 466.075 615.397 466.141C615.375 466.206 615.353 466.272 615.342 466.337C615.178 466.982 614.992 467.638 614.806 468.284C614.621 468.907 614.435 469.53 614.227 470.142C614.216 470.197 614.194 470.251 614.183 470.306C613.975 470.918 613.768 471.542 613.549 472.154C613.527 472.23 613.494 472.307 613.473 472.383C613.221 473.072 612.97 473.75 612.696 474.428C612.172 475.784 611.592 477.128 610.98 478.44C610.881 478.659 610.783 478.878 610.674 479.096C610.63 479.173 610.597 479.26 610.553 479.337C610.466 479.523 610.378 479.698 610.291 479.884C610.007 480.452 609.722 481.021 609.427 481.589C609.373 481.709 609.307 481.819 609.241 481.939C609.176 482.07 609.099 482.212 609.023 482.344C608.979 482.442 608.924 482.54 608.87 482.628C608.706 482.934 608.542 483.229 608.378 483.535C608.323 483.623 608.268 483.71 608.225 483.798C607.897 484.366 607.569 484.924 607.241 485.481C606.956 485.952 606.672 486.411 606.377 486.881C606.082 487.34 605.787 487.799 605.48 488.247C605.338 488.477 605.185 488.696 605.021 488.925C604.923 489.067 604.824 489.221 604.715 489.363C604.475 489.702 604.234 490.051 603.993 490.39C603.753 490.74 603.502 491.079 603.25 491.418C602.867 491.932 602.474 492.446 602.091 492.949C600.899 494.447 599.664 495.901 598.374 497.311C598.363 497.311 598.363 497.311 598.374 497.322C594.974 501.017 591.202 504.363 587.113 507.315C584.849 508.955 582.488 510.464 580.039 511.852C580.028 511.841 580.028 511.841 580.028 511.852C571.194 516.816 561.256 520.041 550.661 521.091C550.246 521.178 549.809 521.222 549.36 521.255C548.923 521.288 548.475 521.309 548.048 521.364C547.655 521.397 547.261 521.441 546.879 521.495C546.682 521.517 546.485 521.539 546.288 521.572C545.315 521.703 544.342 521.845 543.314 521.845C543.292 521.845 543.249 521.834 543.205 521.823C543.533 521.801 543.861 521.758 544.189 521.725C544.932 521.637 545.654 521.517 546.397 521.441C546.638 521.408 546.879 521.386 547.13 521.364C547.567 521.309 548.016 521.288 548.453 521.255H548.464C548.912 521.222 549.349 521.178 549.776 521.091C552.28 520.839 554.761 520.479 557.199 520.008C557.801 519.888 558.413 519.757 559.014 519.626C559.561 519.505 560.108 519.374 560.643 519.243C561.278 519.09 561.901 518.926 562.513 518.74C558.675 519.757 554.707 520.479 550.661 520.872C549.82 521.047 548.912 521.025 548.048 521.145C546.474 521.255 544.954 521.627 543.314 521.627C543.282 521.627 543.227 521.594 543.183 521.594C543.096 521.594 543.008 521.627 542.91 521.627H517.72V597.229H542.91C542.964 597.229 543.008 597.219 543.052 597.219C543.096 597.208 543.139 597.197 543.183 597.197C543.205 597.197 543.227 597.208 543.238 597.219C543.271 597.219 543.292 597.229 543.314 597.229C544.134 597.229 544.921 597.131 545.709 597.033C546.485 596.923 547.261 596.803 548.048 596.748C548.912 596.628 549.82 596.65 550.661 596.475C552.214 596.322 553.756 596.125 555.275 595.874C555.527 595.841 555.789 595.797 556.041 595.754C557.549 595.491 559.047 595.185 560.534 594.835C561.824 594.529 563.103 594.19 564.361 593.829H564.372C565.629 593.458 566.875 593.053 568.1 592.627H568.111C569.346 592.189 570.56 591.73 571.752 591.238H571.762C572.561 590.91 573.348 590.571 574.124 590.21C574.321 590.112 574.518 590.025 574.703 589.937C575.119 589.74 575.534 589.543 575.95 589.347C576.136 589.27 576.322 589.183 576.507 589.084C577.273 588.713 578.027 588.319 578.771 587.925C579.897 587.313 581.012 586.679 582.116 586.012C583.865 584.952 585.56 583.825 587.211 582.623C587.561 582.382 587.9 582.131 588.239 581.868C589.496 580.928 590.721 579.944 591.912 578.927C592.448 578.468 592.973 578.009 593.498 577.539C593.596 577.44 593.705 577.342 593.804 577.255C594.285 576.817 594.755 576.369 595.214 575.921C595.837 575.319 596.461 574.707 597.062 574.084C597.576 573.548 598.09 573.002 598.592 572.455C598.702 572.335 598.811 572.214 598.91 572.094C599.369 571.58 599.828 571.066 600.265 570.542C600.79 569.94 601.293 569.317 601.785 568.694C602.288 568.071 602.769 567.437 603.25 566.802C603.676 566.223 604.103 565.644 604.507 565.053C604.923 564.463 605.327 563.872 605.721 563.271C605.994 562.856 606.268 562.429 606.53 562.003C606.781 561.62 607.022 561.227 607.252 560.833C607.755 560.013 608.225 559.193 608.695 558.351C608.924 557.925 609.154 557.498 609.384 557.072C609.832 556.219 610.258 555.355 610.674 554.492C611.089 553.617 611.494 552.742 611.876 551.846C612.062 551.398 612.248 550.938 612.434 550.49C612.609 550.042 612.795 549.583 612.97 549.134C613.134 548.675 613.309 548.227 613.473 547.768C613.801 546.849 614.107 545.92 614.413 544.991C614.555 544.521 614.697 544.05 614.839 543.569C614.97 543.099 615.102 542.629 615.233 542.159C615.364 541.678 615.484 541.197 615.605 540.727C615.845 539.765 616.064 538.803 616.271 537.829C616.37 537.338 616.468 536.846 616.556 536.364C616.829 534.888 617.059 533.402 617.245 531.904C617.398 530.657 617.518 529.389 617.616 528.121C617.704 526.853 617.769 525.562 617.791 524.283C617.791 524.032 617.802 523.769 617.802 523.507V447.642C617.802 447.871 617.791 448.09 617.791 448.32ZM542.21 521.823C542.254 521.823 542.298 521.845 542.33 521.845C542.585 521.845 542.84 521.836 543.095 521.827C543.08 521.829 543.066 521.831 543.052 521.834C543.008 521.845 542.964 521.845 542.91 521.845H541.926C542.035 521.845 542.112 521.823 542.21 521.823Z",
    fill: "url(#paint90_linear_1962_309)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M449.921 204.029C450.642 204.029 451.364 204.029 452.075 204.051C452.425 204.073 452.764 204.084 453.113 204.084C453.452 204.094 453.802 204.127 454.141 204.138C454.24 204.138 454.338 204.149 454.425 204.149C454.524 204.149 454.622 204.16 454.71 204.171C454.797 204.171 454.885 204.182 454.983 204.193C455.07 204.193 455.169 204.193 455.267 204.204C455.442 204.215 455.617 204.237 455.792 204.248C455.956 204.258 456.131 204.269 456.295 204.291C456.667 204.302 457.006 204.346 457.366 204.379C457.607 204.401 457.858 204.422 458.099 204.455C458.569 204.499 459.028 204.554 459.498 204.608C460.198 204.696 460.898 204.783 461.598 204.893C462.308 205.013 463.008 205.122 463.708 205.264C463.784 205.264 463.861 205.286 463.937 205.297H463.959L463.97 205.308C464.003 205.308 464.047 205.319 464.079 205.33C464.123 205.341 464.178 205.352 464.222 205.363C464.703 205.439 465.184 205.538 465.654 205.647H465.687C465.785 205.658 465.883 205.669 465.982 205.691C466.091 205.713 466.2 205.745 466.31 205.767C466.474 205.811 466.638 205.844 466.802 205.888C466.966 205.92 467.13 205.964 467.294 206.008C467.403 206.03 467.512 206.052 467.622 206.084C467.84 206.128 468.059 206.183 468.278 206.237H468.289C468.551 206.292 468.813 206.358 469.065 206.434C469.207 206.467 469.349 206.511 469.491 206.544C469.601 206.576 469.71 206.598 469.819 206.631C470.082 206.708 470.344 206.773 470.596 206.839V206.85C470.716 206.872 470.836 206.904 470.945 206.948C471.077 206.981 471.208 207.014 471.339 207.057H471.35C471.842 207.2 472.356 207.353 472.859 207.517C473.362 207.67 473.854 207.823 474.346 207.998C474.838 208.162 475.33 208.326 475.822 208.501C475.854 208.501 475.876 208.511 475.898 208.522C476.838 208.872 477.801 209.244 478.741 209.616C478.861 209.67 478.981 209.714 479.102 209.769C479.298 209.845 479.495 209.933 479.692 210.02C479.856 210.075 480.009 210.151 480.173 210.217C480.414 210.315 480.643 210.425 480.884 210.534C481.124 210.633 481.354 210.742 481.594 210.851C481.835 210.961 482.064 211.07 482.305 211.179C482.535 211.288 482.764 211.398 482.994 211.507C484.393 212.174 485.771 212.874 487.105 213.628C487.334 213.759 487.564 213.891 487.793 214.033C487.87 214.066 487.936 214.098 488.012 214.153C488.493 214.415 488.963 214.7 489.433 214.984C490.046 215.356 490.658 215.727 491.259 216.121C491.39 216.208 491.511 216.285 491.631 216.372C491.686 216.394 491.729 216.427 491.773 216.46C491.893 216.536 492.014 216.613 492.134 216.69C492.538 216.963 492.932 217.225 493.326 217.51C493.435 217.575 493.544 217.652 493.654 217.739C493.741 217.805 493.84 217.859 493.927 217.925C494.659 218.439 495.37 218.964 496.081 219.499C496.453 219.784 496.813 220.068 497.174 220.352C497.36 220.505 497.546 220.647 497.732 220.811C497.994 221.019 498.267 221.238 498.53 221.467C498.563 221.489 498.585 221.511 498.617 221.533C498.65 221.555 498.683 221.577 498.705 221.599L498.749 221.642C499.055 221.894 499.35 222.145 499.656 222.408C499.722 222.451 499.776 222.506 499.842 222.572C500.159 222.845 500.476 223.129 500.793 223.402C501.187 223.752 501.569 224.102 501.952 224.463C502.018 224.518 502.083 224.583 502.149 224.649C502.531 225.01 502.925 225.381 503.308 225.764C503.723 226.18 504.16 226.606 504.576 227.032C504.98 227.459 505.396 227.896 505.789 228.344C506.128 228.694 506.445 229.044 506.752 229.394V229.405C506.795 229.438 506.828 229.481 506.861 229.514C506.905 229.558 506.948 229.602 506.981 229.645V229.656C506.992 229.667 507.003 229.678 507.003 229.689C507.08 229.755 507.134 229.831 507.2 229.897C507.539 230.279 507.867 230.662 508.184 231.045C508.326 231.22 508.479 231.406 508.621 231.581C508.807 231.799 508.982 232.007 509.157 232.226V232.236C509.321 232.433 509.463 232.619 509.627 232.827C509.78 233.035 509.944 233.231 510.086 233.428C510.403 233.811 510.688 234.215 510.983 234.609C511.508 235.309 512.021 236.03 512.524 236.752V236.763C512.677 237.003 512.841 237.233 512.994 237.474L513.005 237.484C513.158 237.725 513.322 237.965 513.476 238.206C513.836 238.72 514.142 239.234 514.47 239.769C514.798 240.283 515.094 240.797 515.4 241.311C516.635 243.41 517.739 245.575 518.767 247.794C518.887 248.057 518.997 248.319 519.117 248.593C519.237 248.855 519.358 249.128 519.478 249.391C519.707 249.937 519.937 250.506 520.167 251.063C520.385 251.588 520.571 252.124 520.779 252.638C520.801 252.693 520.812 252.736 520.834 252.78C520.844 252.824 520.866 252.867 520.888 252.911C521.008 253.283 521.151 253.676 521.282 254.059C521.468 254.584 521.654 255.12 521.818 255.655C521.938 256.016 522.058 256.377 522.167 256.738C522.441 257.634 522.703 258.531 522.944 259.449C523.02 259.733 523.097 260.029 523.162 260.324C523.272 260.739 523.37 261.144 523.458 261.548C523.567 262.029 523.676 262.51 523.785 262.992C523.796 263.035 523.807 263.09 523.807 263.134C523.851 263.298 523.884 263.462 523.917 263.637C523.971 263.899 524.026 264.172 524.081 264.446L524.135 264.774L524.168 264.97L524.223 265.233L524.277 265.484V265.495C524.376 266.118 524.485 266.731 524.573 267.365V267.376C524.671 268.01 524.748 268.633 524.824 269.256C524.89 269.748 524.955 270.229 525.01 270.71V270.809C525.043 271.104 525.076 271.41 525.097 271.716C525.13 272.022 525.152 272.328 525.174 272.635C525.229 273.269 525.261 273.914 525.294 274.537C525.316 274.985 525.338 275.423 525.349 275.86C525.36 276.144 525.371 276.45 525.371 276.746C525.393 277.281 525.393 277.817 525.393 278.375V319.538C525.393 319.921 525.404 320.347 525.404 320.839C525.415 322.348 525.425 324.381 525.425 326.852C525.436 327.257 525.436 327.672 525.436 328.099V329.706C525.436 333.303 525.447 337.589 525.458 342.421C525.469 350.501 525.469 360.078 525.469 370.443V372.881C525.469 397.087 525.447 425.196 525.425 448.254V448.703C525.425 458.553 525.415 467.475 525.415 474.756C525.404 485.471 525.393 492.654 525.393 494.053C525.393 496.043 525.283 497.946 525.076 499.761C525.043 500.121 524.999 500.471 524.944 500.821C524.912 501.051 524.879 501.269 524.835 501.499C524.737 502.199 524.616 502.887 524.463 503.554C524.442 503.664 524.42 503.773 524.398 503.871C524.288 504.363 524.168 504.845 524.037 505.315C523.534 507.195 522.878 508.89 522.102 510.377C521.916 510.738 521.719 511.087 521.511 511.415L521.5 511.426C521.293 511.765 521.074 512.093 520.855 512.41C520.844 512.41 520.844 512.41 520.844 512.421C520.506 512.891 520.134 513.329 519.762 513.744C519.39 514.138 518.997 514.509 518.581 514.848C518.516 514.903 518.439 514.958 518.374 515.023C518.297 515.067 518.231 515.133 518.155 515.187C518.013 515.297 517.871 515.406 517.718 515.515V521.627H542.908C543.006 521.627 543.094 521.594 543.181 521.594C543.225 521.594 543.279 521.627 543.312 521.627C544.952 521.627 546.472 521.255 548.046 521.146C548.91 521.026 549.817 521.047 550.659 520.873C554.705 520.479 558.673 519.757 562.511 518.741C562.576 518.73 562.631 518.719 562.697 518.697C562.795 518.675 562.883 518.642 562.981 518.62C563.353 518.511 563.724 518.413 564.096 518.303C564.184 518.281 564.271 518.249 564.359 518.227C564.96 518.052 565.55 517.866 566.141 517.68C566.611 517.527 567.07 517.374 567.529 517.21C568.098 517.013 568.655 516.805 569.213 516.598C569.989 516.313 570.754 516.018 571.509 515.712C572.373 515.351 573.236 514.98 574.089 514.586C574.494 514.4 574.898 514.214 575.303 514.028C575.368 513.996 575.434 513.963 575.499 513.93C576.298 513.547 577.096 513.154 577.883 512.738C578.287 512.52 578.703 512.301 579.107 512.082C579.523 511.853 579.927 511.623 580.332 511.394C580.736 511.164 581.141 510.934 581.535 510.694C582.333 510.213 583.131 509.721 583.907 509.218C584.683 508.715 585.449 508.201 586.214 507.665C586.586 507.403 586.968 507.13 587.34 506.856C588.094 506.31 588.827 505.752 589.56 505.183C594.633 501.182 599.17 496.557 603.051 491.419C603.543 490.774 604.013 490.118 604.472 489.462C604.844 488.948 605.205 488.423 605.555 487.887C605.773 487.559 605.992 487.242 606.2 486.903C606.265 486.805 606.331 486.695 606.397 486.597C606.419 486.564 606.44 486.531 606.462 486.499C606.55 486.356 606.637 486.214 606.736 486.072C606.768 486.018 606.801 485.974 606.834 485.919C606.889 485.821 606.943 485.722 606.998 485.635C607.02 485.613 607.031 485.58 607.064 485.558V485.537C607.085 485.515 607.096 485.482 607.107 485.46C607.304 485.132 607.501 484.804 607.698 484.476C607.752 484.389 607.796 484.301 607.851 484.214C607.894 484.148 607.927 484.082 607.96 484.017C608.08 483.831 608.19 483.645 608.288 483.459C608.397 483.273 608.496 483.077 608.605 482.891C608.671 482.781 608.736 482.672 608.791 482.552C608.922 482.311 609.042 482.082 609.174 481.852C609.294 481.611 609.414 481.382 609.545 481.141C609.83 480.595 610.114 480.037 610.387 479.48C610.442 479.348 610.508 479.228 610.573 479.097C610.792 478.66 611 478.222 611.196 477.785C611.349 477.457 611.481 477.129 611.623 476.812C611.71 476.604 611.798 476.407 611.885 476.2C612.038 475.839 612.213 475.478 612.355 475.106C612.421 474.964 612.476 474.822 612.541 474.68C612.574 474.603 612.607 474.516 612.64 474.428C612.683 474.319 612.727 474.21 612.771 474.089C612.803 473.98 612.847 473.871 612.891 473.751C613.066 473.302 613.241 472.843 613.416 472.395C613.405 472.384 613.405 472.384 613.416 472.384C613.58 471.925 613.744 471.466 613.897 470.995C614.05 470.536 614.214 470.066 614.356 469.596C614.487 469.191 614.618 468.798 614.739 468.393C614.793 468.218 614.848 468.043 614.892 467.869C615.001 467.508 615.099 467.136 615.198 466.775C615.296 466.436 615.384 466.097 615.471 465.769C615.471 465.747 615.482 465.737 615.482 465.715C615.559 465.409 615.646 465.113 615.712 464.807C615.777 464.534 615.843 464.261 615.909 463.987C615.919 463.954 615.919 463.933 615.93 463.9C616.04 463.419 616.149 462.938 616.247 462.446C616.28 462.336 616.302 462.227 616.313 462.118V462.107C616.335 462.052 616.346 461.986 616.368 461.932V461.91C616.379 461.866 616.39 461.812 616.39 461.768C616.39 461.746 616.401 461.735 616.401 461.713C616.411 461.691 616.422 461.658 616.422 461.626C616.433 461.582 616.444 461.538 616.444 461.484C616.455 461.462 616.455 461.44 616.455 461.418C616.488 461.287 616.51 461.156 616.532 461.013C616.532 461.002 616.543 460.992 616.543 460.981C616.543 460.948 616.554 460.915 616.554 460.882C616.586 460.74 616.608 460.609 616.63 460.467C616.63 460.445 616.641 460.423 616.641 460.401C616.652 460.39 616.652 460.379 616.652 460.368C616.707 460.084 616.761 459.789 616.805 459.505C616.805 459.494 616.805 459.483 616.816 459.472C616.882 458.98 616.958 458.499 617.035 458.018C617.177 457.023 617.297 456.017 617.406 455.011C617.461 454.53 617.505 454.049 617.538 453.568C617.538 453.513 617.548 453.459 617.548 453.404C617.57 453.24 617.581 453.076 617.592 452.912C617.614 452.649 617.625 452.387 617.647 452.125C617.658 452.048 617.658 451.961 617.658 451.884C617.658 451.84 617.669 451.797 617.669 451.753C617.669 451.709 617.68 451.666 617.68 451.622C617.68 451.545 617.691 451.458 617.691 451.381C617.712 451.086 617.723 450.802 617.734 450.518V450.441C617.734 450.266 617.745 450.091 617.756 449.916C617.756 449.829 617.767 449.73 617.767 449.643C617.767 449.523 617.778 449.391 617.778 449.271V448.943C617.778 448.735 617.789 448.528 617.789 448.32C617.789 448.09 617.8 447.872 617.8 447.642V277.97C617.8 277.828 617.8 277.686 617.789 277.555C617.789 277.281 617.789 277.008 617.778 276.746C617.778 276.592 617.778 276.45 617.767 276.297C617.767 276.155 617.767 276.002 617.756 275.86C617.756 275.641 617.745 275.423 617.734 275.204C617.723 274.985 617.713 274.767 617.702 274.537C617.669 273.914 617.636 273.269 617.581 272.635C617.559 272.361 617.538 272.088 617.516 271.804C617.505 271.749 617.505 271.694 617.494 271.64C617.472 271.366 617.439 271.082 617.406 270.809V270.71C617.352 270.229 617.297 269.748 617.231 269.256C617.21 269.081 617.188 268.906 617.166 268.731C617.046 267.737 616.903 266.731 616.718 265.747C616.707 265.659 616.685 265.572 616.674 265.484L616.488 264.446C616.302 263.473 616.094 262.51 615.865 261.548C615.854 261.516 615.854 261.494 615.843 261.461C615.766 261.122 615.69 260.783 615.591 260.433C615.591 260.4 615.581 260.357 615.57 260.324C615.559 260.302 615.559 260.269 615.548 260.247C615.493 259.974 615.417 259.712 615.351 259.449C614.87 257.623 614.312 255.83 613.689 254.059C613.558 253.676 613.416 253.283 613.296 252.911C613.252 252.824 613.219 252.736 613.186 252.638C612.978 252.124 612.793 251.588 612.574 251.063C612.344 250.506 612.115 249.937 611.885 249.391C611.645 248.855 611.404 248.319 611.174 247.794C610.748 246.876 610.311 245.958 609.841 245.061C609.206 243.793 608.529 242.536 607.807 241.311C607.556 240.896 607.315 240.48 607.064 240.065C606.998 239.966 606.943 239.868 606.878 239.769C606.714 239.507 606.55 239.245 606.397 238.982C606.233 238.72 606.069 238.457 605.883 238.206C605.577 237.714 605.238 237.233 604.932 236.752C604.538 236.205 604.155 235.659 603.762 235.123C603.641 234.948 603.521 234.784 603.39 234.609C603.248 234.412 603.095 234.215 602.953 234.019C602.8 233.822 602.658 233.625 602.494 233.428C602.198 233.035 601.87 232.619 601.564 232.226C600.919 231.427 600.274 230.662 599.607 229.897C599.454 229.733 599.323 229.558 599.159 229.394C598.962 229.164 598.754 228.935 598.536 228.705C598.426 228.585 598.317 228.465 598.197 228.344C598.098 228.224 597.989 228.115 597.891 227.994C597.584 227.666 597.278 227.349 596.983 227.032L596.349 226.398C596.251 226.289 596.141 226.179 596.032 226.081C595.923 225.972 595.813 225.862 595.715 225.764C593.769 223.851 591.724 222.047 589.581 220.352C589.221 220.068 588.86 219.784 588.488 219.499C587.843 219.007 587.187 218.526 586.531 218.067C585.952 217.652 585.372 217.247 584.782 216.853C584.563 216.7 584.344 216.558 584.115 216.416C583.885 216.263 583.656 216.121 583.426 215.968C582.442 215.334 581.436 214.732 580.419 214.153C580.113 213.967 579.818 213.792 579.512 213.628C579.173 213.442 578.845 213.256 578.506 213.082C578.167 212.896 577.839 212.721 577.489 212.546C576.801 212.185 576.101 211.846 575.401 211.507C575.171 211.398 574.942 211.288 574.712 211.179C574.472 211.07 574.242 210.961 574.002 210.851C573.761 210.742 573.531 210.633 573.291 210.534C573.05 210.425 572.821 210.315 572.58 210.217C572.34 210.119 572.11 210.009 571.87 209.922C571.749 209.867 571.629 209.813 571.509 209.769C571.389 209.714 571.268 209.659 571.148 209.616C570.951 209.539 570.754 209.463 570.558 209.386C570.284 209.277 570.011 209.167 569.738 209.069C569.257 208.883 568.776 208.697 568.305 208.522C568.284 208.511 568.262 208.501 568.229 208.501C567.245 208.162 566.261 207.812 565.266 207.517C564.763 207.353 564.249 207.2 563.746 207.057C563.254 206.904 562.751 206.773 562.227 206.631C562.106 206.598 561.986 206.565 561.855 206.533C561.724 206.5 561.592 206.467 561.472 206.434C561.221 206.358 560.958 206.292 560.696 206.237H560.685C560.357 206.161 560.029 206.073 559.701 206.008C559.537 205.964 559.373 205.92 559.209 205.888C559.045 205.844 558.881 205.811 558.717 205.767C558.498 205.713 558.28 205.669 558.061 205.647C557.591 205.538 557.11 205.439 556.629 205.363C556.607 205.363 556.596 205.352 556.574 205.352C556.41 205.308 556.268 205.286 556.115 205.264C555.415 205.122 554.715 205.013 554.005 204.893C553.305 204.783 552.605 204.696 551.906 204.608C551.436 204.554 550.976 204.499 550.506 204.455C550.266 204.422 550.014 204.401 549.774 204.379C549.413 204.346 549.074 204.302 548.702 204.291C548.374 204.248 548.024 204.237 547.675 204.204C547.587 204.204 547.489 204.193 547.401 204.193C547.303 204.182 547.215 204.182 547.117 204.171C546.931 204.149 546.745 204.149 546.548 204.138C546.209 204.127 545.86 204.094 545.521 204.084C545.171 204.084 544.832 204.073 544.482 204.051C544.121 204.04 543.771 204.04 543.411 204.04C543.05 204.029 542.689 204.029 542.328 204.029H449.921Z",
    fill: "url(#paint91_linear_1962_309)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M261.346 299.727C259.444 299.727 257.551 299.792 255.682 299.945C255.081 299.989 254.479 300.044 253.879 300.098C216.269 303.859 187.076 335.445 187.076 374.072V526.098C188.816 565.687 221.298 597.229 261.346 597.229H278.379C280.403 597.219 282.359 597.142 284.24 597.011C284.262 597.011 284.294 597.011 284.316 597C284.611 596.956 284.906 596.912 285.202 596.88C285.257 596.869 285.3 596.858 285.356 596.858C285.716 596.814 286.076 596.77 286.438 596.748C287.302 596.628 288.209 596.65 289.051 596.475C289.652 596.42 290.254 596.344 290.855 596.267C291.03 596.256 291.193 596.235 291.368 596.213C291.401 596.202 291.424 596.202 291.456 596.191C291.477 596.191 291.511 596.18 291.533 596.18H291.555C294.342 595.743 296.967 595.174 299.447 594.496C300.727 594.157 301.963 593.786 303.166 593.381C303.723 593.195 304.269 593.009 304.817 592.812C305.134 592.703 305.439 592.583 305.745 592.463C306.171 592.31 306.588 592.146 306.992 591.982C307.408 591.818 307.811 591.654 308.205 591.479C308.609 591.315 309.003 591.14 309.386 590.965C309.779 590.801 310.162 590.626 310.546 590.44C310.917 590.265 311.288 590.079 311.66 589.893C312.011 589.718 312.349 589.543 312.689 589.369C314.154 588.614 315.542 587.816 316.843 586.996C317.072 586.854 317.302 586.701 317.532 586.559C318.013 586.253 318.471 585.936 318.93 585.618C319.455 585.269 319.97 584.908 320.473 584.536C321.042 584.121 321.598 583.694 322.124 583.279C324.201 581.639 326.015 579.977 327.579 578.37C328.356 577.593 329.055 576.828 329.689 576.085C329.897 575.855 330.094 575.625 330.291 575.396C330.707 574.893 331.111 574.412 331.472 573.931C331.778 573.559 332.062 573.187 332.313 572.827C332.86 572.105 333.329 571.416 333.746 570.793C333.866 570.607 333.985 570.421 334.095 570.246C334.215 570.071 334.325 569.897 334.424 569.733C334.499 569.623 334.565 569.525 334.621 569.415C334.794 569.12 334.958 568.858 335.09 568.617C335.155 568.497 335.222 568.388 335.275 568.289C335.506 567.885 335.68 567.557 335.801 567.316C335.866 567.196 335.911 567.098 335.953 567.021C335.975 566.966 335.986 566.934 336.009 566.901C336.042 566.835 336.052 566.802 336.052 566.802L336.534 565.348C343.618 543.865 327.611 521.758 305.003 521.758C299.644 521.758 294.671 520.183 290.493 517.461C286.329 514.739 282.972 510.879 280.85 506.32C279.276 502.887 278.379 499.06 278.379 495.026V326.338C278.379 323.889 278.707 321.527 279.331 319.275C281.08 312.814 285.201 307.347 290.712 303.859C294.823 301.246 299.722 299.727 305.003 299.727H261.346Z",
    fill: "url(#paint92_linear_1962_309)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M261.347 204.03C220.172 204.03 187 237.201 187 278.376V522.732C187 523.858 187.023 524.973 187.077 526.1V374.074C187.077 371.012 187.263 367.984 187.624 365.021C187.678 364.496 187.754 363.971 187.821 363.458C187.875 363.064 187.941 362.67 188.007 362.288C188.071 361.818 188.148 361.347 188.237 360.888C188.346 360.276 188.465 359.664 188.585 359.062C188.707 358.461 188.827 357.882 188.968 357.291C188.968 357.258 188.979 357.237 188.991 357.215C189.122 356.624 189.263 356.034 189.417 355.454C189.516 355.039 189.625 354.624 189.744 354.219C189.864 353.782 189.986 353.344 190.117 352.918C190.225 352.513 190.346 352.12 190.478 351.726C190.587 351.376 190.697 351.027 190.816 350.677C190.914 350.36 191.012 350.053 191.122 349.747C191.768 347.878 192.479 346.052 193.266 344.259C193.419 343.898 193.582 343.537 193.747 343.177C196.119 337.95 199.081 333.052 202.558 328.57C202.82 328.231 203.084 327.892 203.357 327.553C203.969 326.788 204.591 326.033 205.249 325.301C205.575 324.907 205.926 324.514 206.275 324.131C206.331 324.054 206.395 323.989 206.461 323.923C206.767 323.584 207.084 323.245 207.402 322.917C207.905 322.371 208.419 321.846 208.943 321.332C209.294 320.982 209.655 320.632 210.014 320.282C210.475 319.845 210.945 319.408 211.414 318.981C211.841 318.588 212.278 318.205 212.727 317.822C212.955 317.626 213.174 317.429 213.405 317.243C213.733 316.959 214.06 316.685 214.389 316.423C217.461 313.919 220.74 311.645 224.195 309.655C224.687 309.371 225.179 309.087 225.682 308.814C226.186 308.54 226.689 308.267 227.202 308.015C227.585 307.808 227.968 307.611 228.35 307.436C229.29 306.955 230.242 306.507 231.215 306.091C231.586 305.916 231.957 305.752 232.34 305.599C232.713 305.435 233.084 305.282 233.455 305.14C233.97 304.921 234.484 304.724 234.997 304.528C235.042 304.517 235.085 304.495 235.128 304.484C235.643 304.287 236.167 304.101 236.691 303.915C237.114 303.762 237.554 303.618 237.988 303.474C238.292 303.374 238.594 303.276 238.899 303.181C239.057 303.13 239.211 303.077 239.371 303.03C239.776 302.91 240.18 302.778 240.596 302.669C240.671 302.646 240.749 302.628 240.824 302.605C241.482 302.418 242.138 302.226 242.803 302.057C242.946 302.024 243.076 301.991 243.22 301.958C243.678 301.838 244.138 301.729 244.597 301.63C245.17 301.495 245.746 301.371 246.33 301.254C246.571 301.206 246.812 301.161 247.054 301.115C247.263 301.075 247.469 301.028 247.679 300.996C247.866 300.953 248.052 300.92 248.238 300.887C248.347 300.865 248.457 300.843 248.566 300.832C249.068 300.745 249.571 300.657 250.074 300.581C250.161 300.57 250.239 300.559 250.326 300.548C250.829 300.471 251.342 300.395 251.856 300.329C251.932 300.318 252.02 300.307 252.097 300.297C252.61 300.242 253.124 300.176 253.639 300.133C253.692 300.122 253.748 300.122 253.802 300.111C254.426 300.045 255.049 299.99 255.682 299.947C256.317 299.892 256.951 299.859 257.586 299.826C258.142 299.794 258.7 299.772 259.259 299.761C259.368 299.75 259.487 299.75 259.607 299.75C260.187 299.739 260.766 299.728 261.347 299.728H499.657C508.184 299.728 515.75 303.708 520.616 309.918C522.813 312.717 524.465 315.986 525.393 319.539V299.728V278.376C525.393 277.818 525.393 277.282 525.371 276.746C525.371 276.451 525.361 276.145 525.35 275.861C525.339 275.424 525.318 274.986 525.295 274.538C525.262 273.915 525.23 273.27 525.174 272.636C525.154 272.329 525.132 272.023 525.098 271.717C525.076 271.411 525.044 271.105 525.01 270.81V270.711C524.957 270.23 524.89 269.749 524.826 269.257C524.749 268.634 524.672 268 524.574 267.366C524.486 266.732 524.376 266.109 524.278 265.485L524.17 264.971L524.071 264.447C523.983 263.955 523.885 263.474 523.787 262.993C523.678 262.511 523.568 262.03 523.459 261.549C523.371 261.145 523.273 260.74 523.164 260.325C523.098 260.03 523.02 259.734 522.944 259.45C522.452 257.624 521.906 255.831 521.271 254.06C521.14 253.677 521.01 253.284 520.878 252.912C520.845 252.825 520.813 252.737 520.779 252.639C520.571 252.125 520.386 251.589 520.167 251.064C519.938 250.507 519.697 249.938 519.467 249.392C519.228 248.856 518.997 248.32 518.767 247.795C517.741 245.576 516.636 243.411 515.401 241.312C515.095 240.798 514.8 240.284 514.471 239.77C514.143 239.235 513.827 238.721 513.476 238.207C513.16 237.715 512.832 237.234 512.526 236.753C512.022 236.031 511.508 235.31 510.984 234.61C510.689 234.216 510.394 233.812 510.088 233.429C509.944 233.232 509.781 233.036 509.627 232.828C509.463 232.62 509.311 232.423 509.146 232.227C508.829 231.833 508.502 231.439 508.184 231.046C507.856 230.663 507.518 230.28 507.189 229.898C507.048 229.734 506.905 229.559 506.753 229.395C506.447 229.045 506.13 228.695 505.79 228.345C505.396 227.897 504.982 227.46 504.577 227.033C504.162 226.607 503.723 226.181 503.309 225.765C502.489 224.956 501.657 224.169 500.793 223.403C500.476 223.13 500.16 222.846 499.843 222.573C499.777 222.507 499.722 222.452 499.657 222.409C499.286 222.091 498.913 221.785 498.53 221.468C498.269 221.239 497.996 221.02 497.732 220.812C497.546 220.648 497.36 220.506 497.176 220.353C496.815 220.069 496.453 219.785 496.081 219.5C493.24 217.336 490.243 215.378 487.105 213.629C485.772 212.875 484.395 212.175 482.994 211.508C482.536 211.29 482.076 211.071 481.595 210.852C481.114 210.634 480.656 210.426 480.174 210.218C479.693 210.01 479.222 209.814 478.741 209.617C477.802 209.245 476.84 208.873 475.898 208.523C475.877 208.512 475.856 208.502 475.823 208.502C474.839 208.163 473.855 207.813 472.859 207.518C472.356 207.354 471.853 207.201 471.35 207.058H471.34C470.847 206.905 470.346 206.774 469.821 206.632C469.329 206.501 468.814 206.359 468.289 206.238H468.279C467.622 206.074 466.967 205.921 466.311 205.768C466.092 205.714 465.873 205.67 465.654 205.648C465.184 205.539 464.704 205.44 464.223 205.364C464.048 205.32 463.883 205.276 463.708 205.265C463.008 205.123 462.309 205.014 461.599 204.894C460.21 204.686 458.788 204.511 457.368 204.38C457.006 204.347 456.668 204.303 456.295 204.292C455.968 204.249 455.617 204.238 455.269 204.205C454.886 204.183 454.535 204.15 454.141 204.139C453.804 204.128 453.453 204.095 453.115 204.085C452.764 204.085 452.426 204.074 452.075 204.052C451.364 204.03 450.644 204.03 449.921 204.03H261.347Z",
    fill: "url(#paint93_linear_1962_309)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M406.201 671.707C406.201 688.282 411.613 703.501 420.753 715.779C432.955 732.168 451.814 743.331 473.342 745.452C474.184 745.627 475.091 745.605 475.955 745.725C477.529 745.834 479.049 746.206 480.689 746.206C480.722 746.206 480.776 746.173 480.82 746.173C480.908 746.173 480.995 746.206 481.093 746.206H612.467C615.681 746.206 618.764 747.124 621.202 749.114L710.439 814.998C715.829 819.01 722.126 821 728.413 821C729.78 821 731.146 820.902 732.524 820.694C737.302 820.016 742.014 818.146 746.081 815.162C756.839 807.487 761.289 793.798 757.135 781.203L746.201 747.966L745.622 746.206H742.703C742.593 746.206 742.517 746.173 742.418 746.173C742.375 746.173 742.331 746.206 742.309 746.206C741.894 746.206 741.489 746.184 741.096 746.151C741.041 746.14 740.986 746.14 740.943 746.13C740.789 746.119 740.636 746.108 740.494 746.086C740.461 746.086 740.418 746.075 740.385 746.075C740.287 746.064 740.177 746.042 740.079 746.031C739.969 746.02 739.871 745.998 739.762 745.987H739.729C739.718 745.987 739.696 745.987 739.685 745.976C739.095 745.944 738.504 745.889 737.925 745.834C737.072 745.758 736.23 745.67 735.41 745.561C734.47 745.452 733.541 745.331 732.633 745.189C732.611 745.178 732.6 745.178 732.579 745.178C732.557 745.178 732.535 745.167 732.513 745.167C732.502 745.156 732.48 745.156 732.469 745.156H732.447C731.835 745.058 731.223 744.96 730.622 744.85C730.545 744.829 730.469 744.818 730.392 744.807L730.228 744.774C730.217 744.774 730.217 744.774 730.206 744.763C730.141 744.763 730.075 744.741 730.009 744.73C729.922 744.719 729.845 744.697 729.758 744.675C729.463 744.632 729.167 744.566 728.872 744.501C727.976 744.326 727.09 744.118 726.237 743.91C726.084 743.877 725.931 743.834 725.789 743.801C725.581 743.746 725.374 743.691 725.166 743.637C724.958 743.593 724.761 743.527 724.554 743.473C724.105 743.353 723.657 743.232 723.231 743.101C723.089 743.068 722.946 743.025 722.815 742.981C722.772 742.97 722.717 742.959 722.662 742.937C722.039 742.751 721.438 742.565 720.836 742.358C720.279 742.172 719.732 741.986 719.185 741.789C719.043 741.745 718.912 741.691 718.781 741.636C718.606 741.57 718.431 741.505 718.256 741.45C718.081 741.385 717.906 741.319 717.742 741.253C717.709 741.231 717.666 741.221 717.622 741.21C717.25 741.057 716.89 740.914 716.529 740.772C716.288 740.663 716.037 740.565 715.796 740.466C715.599 740.379 715.403 740.291 715.206 740.204C715.075 740.149 714.954 740.094 714.823 740.04C714.758 740.018 714.692 739.985 714.615 739.952C714.222 739.777 713.839 739.592 713.456 739.417C713.085 739.242 712.713 739.056 712.341 738.87C711.991 738.706 711.652 738.531 711.314 738.345C711.106 738.236 710.909 738.137 710.712 738.028C710.526 737.93 710.351 737.842 710.177 737.744C709.914 737.602 709.652 737.46 709.4 737.306C709.389 737.306 709.389 737.306 709.378 737.296C709.018 737.099 708.668 736.891 708.329 736.683C708.263 736.65 708.198 736.618 708.143 736.574C707.804 736.377 707.476 736.18 707.159 735.973C706.929 735.83 706.7 735.677 706.47 735.535C706.23 735.382 705.989 735.229 705.76 735.065C705.683 735.021 705.606 734.967 705.53 734.912C705.442 734.857 705.366 734.803 705.289 734.759C705.18 734.683 705.071 734.606 704.961 734.529C704.83 734.442 704.699 734.355 704.568 734.256C704.218 734.016 703.868 733.764 703.529 733.513C702.961 733.097 702.403 732.671 701.878 732.255C701.364 731.851 700.861 731.435 700.37 731.02C700.271 730.943 700.173 730.856 700.074 730.768C699.856 730.583 699.648 730.408 699.44 730.222C699.429 730.211 699.418 730.2 699.407 730.2C699.331 730.123 699.265 730.058 699.189 730.003C699.112 729.927 699.036 729.861 698.959 729.784C698.467 729.347 697.997 728.899 697.538 728.462C697.461 728.385 697.385 728.319 697.308 728.232C697.21 728.144 697.122 728.057 697.024 727.948C696.816 727.751 696.619 727.543 696.423 727.346L696.291 727.215C696.095 727.018 695.909 726.832 695.734 726.636C695.723 726.625 695.712 726.614 695.701 726.603C695.603 726.504 695.515 726.406 695.417 726.308C695.384 726.264 695.34 726.22 695.318 726.187C695.253 726.133 695.198 726.067 695.143 726.002C695.023 725.87 694.914 725.75 694.804 725.619C694.739 725.553 694.673 725.477 694.608 725.4C694.509 725.291 694.411 725.171 694.312 725.061C694.269 725.018 694.225 724.974 694.192 724.93C694.159 724.897 694.127 724.865 694.105 724.832C694.094 724.821 694.083 724.81 694.083 724.81C693.952 724.657 693.831 724.515 693.711 724.373C693.667 724.318 693.613 724.252 693.569 724.198C693.405 724.001 693.252 723.815 693.099 723.629C693.066 723.596 693.033 723.563 693.011 723.52C692.891 723.389 692.782 723.246 692.672 723.104C692.607 723.028 692.552 722.94 692.487 722.864C692.41 722.765 692.334 722.667 692.257 722.569C692.202 722.492 692.148 722.426 692.093 722.35C692.06 722.306 692.027 722.273 691.995 722.23C691.984 722.208 691.962 722.186 691.951 722.164C691.863 722.044 691.776 721.923 691.689 721.803C691.634 721.738 691.59 721.672 691.535 721.606C691.459 721.497 691.371 721.377 691.295 721.267C691.229 721.18 691.164 721.103 691.109 721.016C691.022 720.885 690.934 720.765 690.847 720.644C690.814 720.601 690.792 720.568 690.77 720.535C690.595 720.273 690.42 720.01 690.256 719.77C690.18 719.66 690.103 719.551 690.038 719.442C690.027 719.42 690.016 719.398 689.994 719.376C689.95 719.31 689.917 719.256 689.874 719.19C689.808 719.081 689.742 718.982 689.688 718.884C689.644 718.818 689.611 718.764 689.578 718.709C689.502 718.6 689.436 718.49 689.382 718.392C689.305 718.261 689.239 718.152 689.163 718.031C689.152 718.02 689.141 717.998 689.141 717.988C689.054 717.845 688.977 717.714 688.911 717.594C688.879 717.528 688.846 717.485 688.813 717.43C688.78 717.375 688.747 717.321 688.726 717.266C688.704 717.222 688.682 717.189 688.66 717.157C688.627 717.091 688.594 717.036 688.562 716.982C688.409 716.697 688.288 716.479 688.201 716.293C688.179 716.26 688.168 716.227 688.146 716.194C688.135 716.184 688.135 716.173 688.124 716.162C688.124 716.151 688.124 716.14 688.113 716.129C688.092 716.085 688.07 716.041 688.048 715.998C688.026 715.943 688.015 715.91 687.993 715.877C687.96 715.812 687.949 715.779 687.949 715.779L677.224 707.863L636.093 677.502C632.223 674.605 627.718 672.604 622.995 671.576C621.29 671.194 619.551 670.942 617.813 670.822C616.982 670.756 616.151 670.734 615.32 670.734H524.345C523.624 670.734 522.88 670.691 522.104 670.603H481.093C480.995 670.603 480.908 670.57 480.82 670.57C480.776 670.57 480.722 670.603 480.689 670.603C479.049 670.603 477.529 670.231 475.955 670.122C475.091 670.002 474.184 670.024 473.342 669.849C468.641 669.39 464.049 668.493 459.643 667.203C464.322 668.613 469.209 669.575 474.227 670.067C475.091 670.242 475.999 670.231 476.873 670.341C478.196 670.439 479.475 670.702 480.82 670.8C480.776 670.8 480.722 670.822 480.689 670.822C479.049 670.822 477.529 670.461 475.955 670.341C475.091 670.231 474.184 670.242 473.342 670.067C451.814 667.946 432.955 656.784 420.753 640.395C420.25 639.717 419.758 639.028 419.288 638.339C419.015 637.968 418.763 637.596 418.523 637.224C417.309 635.409 416.183 633.54 415.134 631.604C415.035 631.44 414.948 631.266 414.849 631.091C414.751 630.916 414.663 630.741 414.576 630.566C414.281 629.997 413.997 629.429 413.712 628.86C413.625 628.674 413.537 628.499 413.45 628.314C413.406 628.237 413.373 628.15 413.33 628.073C413.22 627.854 413.122 627.636 413.023 627.417C412.411 626.105 411.832 624.76 411.307 623.405C411.034 622.727 410.782 622.049 410.531 621.36C410.509 621.284 410.476 621.207 410.454 621.13C410.236 620.518 410.028 619.895 409.82 619.283C409.809 619.228 409.787 619.173 409.776 619.119C409.569 618.506 409.383 617.883 409.197 617.26C409.011 616.615 408.825 615.959 408.661 615.314C408.65 615.248 408.628 615.183 408.606 615.117C408.585 615.052 408.574 614.997 408.563 614.953C408.191 613.543 407.874 612.122 407.59 610.689C407.59 610.667 407.579 610.635 407.579 610.602C407.491 610.175 407.415 609.76 407.349 609.344C407.294 609.06 407.24 608.765 407.196 608.481C407.12 607.978 407.043 607.486 406.966 606.994C406.813 605.999 406.693 604.993 406.595 603.987C406.54 603.506 406.496 603.025 406.464 602.544C406.442 602.325 406.42 602.107 406.409 601.888C406.387 601.626 406.376 601.363 406.354 601.101C406.343 601.024 406.343 600.937 406.343 600.86C406.343 600.817 406.332 600.773 406.332 600.729C406.332 600.685 406.321 600.642 406.321 600.598C406.321 600.521 406.311 600.434 406.311 600.357C406.289 600.073 406.278 599.778 406.267 599.494C406.256 599.297 406.245 599.089 406.245 598.892C406.245 598.805 406.234 598.706 406.234 598.619C406.234 598.499 406.223 598.368 406.223 598.247V598.051C406.212 597.799 406.212 597.548 406.212 597.296C406.212 597.067 406.201 596.848 406.201 596.618V671.707ZM481.793 670.8C481.892 670.8 481.968 670.822 482.077 670.822H481.093C481.013 670.822 480.938 670.808 480.865 670.802C481.135 670.812 481.404 670.822 481.673 670.822C481.706 670.822 481.75 670.8 481.793 670.8Z",
    fill: "url(#paint94_linear_1962_309)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M481.673 353.004C480.951 353.004 480.23 353.004 479.519 353.026C479.169 353.048 478.83 353.059 478.48 353.059C478.142 353.07 477.792 353.103 477.453 353.114C477.059 353.125 476.709 353.158 476.327 353.179C475.977 353.212 475.627 353.223 475.299 353.267C474.927 353.278 474.588 353.322 474.227 353.354C472.806 353.486 471.385 353.66 469.996 353.868C469.286 353.988 468.586 354.098 467.886 354.24C467.711 354.251 467.547 354.295 467.372 354.338C466.891 354.415 466.41 354.513 465.94 354.623C465.721 354.644 465.503 354.688 465.284 354.743C464.628 354.896 463.972 355.049 463.316 355.213H463.305C462.78 355.333 462.267 355.475 461.775 355.607C461.25 355.749 460.747 355.88 460.255 356.033C459.752 356.175 459.238 356.328 458.735 356.492C457.74 356.787 456.756 357.137 455.772 357.476C455.739 357.476 455.718 357.487 455.696 357.498C454.755 357.848 453.793 358.22 452.853 358.591C452.372 358.788 451.902 358.985 451.421 359.193C450.94 359.4 450.481 359.608 450 359.827C449.518 360.045 449.059 360.264 448.6 360.483C447.201 361.15 445.823 361.849 444.489 362.604C441.351 364.353 438.356 366.31 435.513 368.475C435.141 368.759 434.781 369.043 434.42 369.328C432.277 371.022 430.232 372.826 428.286 374.74C427.871 375.155 427.433 375.581 427.018 376.008C426.613 376.434 426.198 376.872 425.804 377.32C425.465 377.67 425.148 378.02 424.842 378.369C424.678 378.533 424.547 378.708 424.394 378.872C423.727 379.638 423.082 380.403 422.437 381.201C422.131 381.595 421.803 382.01 421.508 382.404C421.191 382.786 420.906 383.191 420.611 383.585C420.086 384.284 419.572 385.006 419.07 385.727C418.763 386.209 418.424 386.69 418.118 387.182C417.758 387.695 417.451 388.209 417.123 388.745C416.795 389.259 416.5 389.773 416.194 390.287C414.959 392.386 413.854 394.551 412.827 396.77C412.597 397.295 412.357 397.831 412.116 398.366C411.886 398.913 411.657 399.481 411.427 400.039C411.209 400.564 411.023 401.1 410.815 401.613C410.782 401.712 410.749 401.799 410.706 401.887C410.585 402.258 410.443 402.652 410.312 403.035C409.689 404.806 409.131 406.599 408.65 408.425C408.574 408.709 408.497 409.004 408.432 409.299C408.322 409.715 408.224 410.119 408.136 410.524C407.907 411.486 407.699 412.448 407.513 413.421L407.327 414.46C407.098 415.706 406.912 416.975 406.77 418.232C406.704 418.724 406.649 419.205 406.595 419.686V419.784C406.518 420.386 406.464 421.009 406.42 421.61C406.365 422.244 406.332 422.889 406.3 423.513C406.278 423.961 406.256 424.398 406.245 424.835C406.234 425.12 406.223 425.426 406.223 425.721C406.201 426.257 406.201 426.793 406.201 427.35V596.618C406.201 596.847 406.212 597.066 406.212 597.296C406.212 597.503 406.223 597.711 406.223 597.919V598.247C406.223 598.367 406.234 598.498 406.234 598.618C406.234 598.706 406.245 598.804 406.245 598.892C406.256 599.067 406.267 599.242 406.267 599.417V599.493C406.278 599.777 406.289 600.062 406.311 600.357C406.311 600.433 406.321 600.521 406.321 600.597C406.321 600.641 406.332 600.685 406.332 600.729C406.332 600.772 406.343 600.816 406.343 600.86C406.343 600.936 406.343 601.024 406.354 601.1C406.376 601.363 406.387 601.625 406.409 601.887C406.42 602.051 406.431 602.215 406.453 602.379C406.453 602.434 406.464 602.489 406.464 602.543C406.496 603.025 406.54 603.506 406.595 603.987C406.704 604.992 406.824 605.998 406.966 606.993C407.043 607.485 407.12 607.977 407.196 608.48C407.24 608.764 407.294 609.06 407.349 609.344C407.349 609.355 407.349 609.366 407.36 609.377C407.382 609.541 407.415 609.694 407.448 609.858C407.448 609.902 407.458 609.945 407.469 609.989C407.491 610.131 407.513 610.262 407.546 610.393C407.546 610.47 407.568 610.536 407.579 610.601C407.579 610.634 407.59 610.667 407.601 610.689C407.622 610.831 407.644 610.962 407.688 611.093C407.699 611.203 407.721 611.312 407.754 611.421C407.852 611.913 407.961 612.394 408.071 612.875C408.213 613.488 408.355 614.089 408.519 614.69C408.606 615.04 408.705 615.39 408.803 615.751C409.055 616.702 409.328 617.642 409.645 618.572C409.787 619.042 409.951 619.512 410.104 619.971C410.421 620.9 410.749 621.819 411.11 622.726C411.274 623.185 411.449 623.634 411.646 624.082C411.793 624.452 411.963 624.812 412.119 625.177C412.206 625.379 412.293 625.582 412.381 625.782C412.526 626.107 412.656 626.437 412.805 626.76C413.002 627.198 413.209 627.635 413.428 628.072C413.494 628.204 413.559 628.324 413.614 628.455C413.887 629.013 414.171 629.57 414.456 630.117C414.707 630.598 414.948 631.057 415.21 631.527C415.265 631.648 415.33 631.757 415.396 631.866C415.604 632.249 415.811 632.621 416.041 632.992C416.074 633.058 416.107 633.124 416.15 633.189C416.391 633.605 416.642 634.02 416.894 634.436C416.916 634.49 416.959 634.556 417.003 634.61C417.08 634.753 417.167 634.906 417.266 635.048C417.364 635.19 417.451 635.332 417.539 635.474C417.834 635.944 418.14 636.404 418.446 636.863C418.796 637.398 419.157 637.923 419.529 638.437C419.988 639.093 420.458 639.749 420.95 640.394C429.817 652.147 442.149 661.222 456.472 666.186C456.931 666.35 457.39 666.503 457.86 666.656C458.451 666.842 459.041 667.027 459.643 667.202C464.049 668.492 468.641 669.389 473.342 669.848C474.184 670.023 475.091 670.001 475.955 670.121C477.529 670.231 479.049 670.603 480.689 670.603C480.722 670.603 480.776 670.57 480.82 670.57C480.908 670.57 480.995 670.603 481.093 670.603H498.608H522.104C516.386 669.979 509.52 667.17 505.42 663.824C501.025 660.249 498.608 652.552 498.608 643.029C498.608 641.63 498.598 634.447 498.587 623.732C498.587 616.341 498.576 607.256 498.576 597.23C498.554 574.172 498.532 546.063 498.532 521.857V521.758C498.532 510.497 498.532 500.078 498.543 491.397C498.554 485.821 498.565 480.966 498.565 477.074C498.576 474.035 498.587 471.575 498.598 469.815C498.598 469.323 498.608 468.896 498.608 468.514V427.35C498.608 426.793 498.608 426.257 498.63 425.721C498.63 425.426 498.641 425.12 498.652 424.835C498.663 424.398 498.685 423.961 498.707 423.513C498.74 422.889 498.772 422.244 498.827 421.61C498.849 421.304 498.871 420.998 498.904 420.692C498.926 420.386 498.958 420.08 498.991 419.784V419.686C499.046 419.205 499.111 418.724 499.177 418.232C499.254 417.609 499.33 416.975 499.428 416.34C499.516 415.706 499.625 415.083 499.724 414.46L499.833 413.946L499.866 413.749L499.92 413.421C500.019 412.929 500.106 412.448 500.216 411.967C500.325 411.486 500.434 411.005 500.544 410.524C500.631 410.119 500.729 409.715 500.839 409.299C500.904 409.004 500.981 408.709 501.057 408.425C501.539 406.599 502.096 404.806 502.719 403.035C502.851 402.652 502.993 402.258 503.113 401.887C503.157 401.799 503.189 401.712 503.222 401.613C503.43 401.1 503.616 400.564 503.834 400.039C504.064 399.481 504.294 398.913 504.523 398.366C504.764 397.831 505.004 397.295 505.234 396.77C506.262 394.551 507.366 392.386 508.601 390.287C508.908 389.773 509.203 389.259 509.531 388.745C509.859 388.209 510.165 387.695 510.526 387.182C510.832 386.69 511.171 386.209 511.477 385.727C511.98 385.006 512.494 384.284 513.018 383.585C513.314 383.191 513.598 382.786 513.915 382.404C514.057 382.207 514.221 382.01 514.374 381.802C514.538 381.595 514.691 381.398 514.844 381.201C515.172 380.808 515.489 380.414 515.817 380.02C516.134 379.638 516.462 379.255 516.801 378.872C516.954 378.708 517.086 378.533 517.25 378.369C517.556 378.02 517.873 377.67 518.212 377.32C518.605 376.872 519.021 376.434 519.425 376.008C519.841 375.581 520.278 375.155 520.693 374.74C521.076 374.357 521.47 373.985 521.852 373.624C521.918 373.559 521.984 373.493 522.049 373.439C522.432 373.078 522.815 372.728 523.208 372.378C523.361 372.236 523.525 372.094 523.678 371.963C523.733 371.919 523.777 371.875 523.831 371.831C523.941 371.733 524.05 371.646 524.159 371.547C524.225 371.482 524.28 371.427 524.345 371.383C524.651 371.121 524.947 370.869 525.253 370.618L525.296 370.574C525.482 370.421 525.657 370.279 525.843 370.137C525.985 370.016 526.127 369.896 526.269 369.787C526.455 369.623 526.641 369.481 526.827 369.328C527.188 369.043 527.549 368.759 527.92 368.475C530.763 366.31 533.759 364.353 536.896 362.604C538.23 361.849 539.608 361.15 541.007 360.483C541.467 360.264 541.926 360.045 542.407 359.827C542.888 359.608 543.347 359.4 543.828 359.193C544.309 358.985 544.779 358.788 545.26 358.591C546.201 358.22 547.163 357.848 548.103 357.498C548.125 357.487 548.147 357.476 548.18 357.476C549.164 357.137 550.147 356.787 551.142 356.492C551.645 356.328 552.159 356.175 552.651 356.033H552.662C553.154 355.88 553.657 355.749 554.182 355.607C554.674 355.475 555.188 355.333 555.712 355.213H555.723C556.379 355.049 557.035 354.896 557.691 354.743C557.91 354.688 558.129 354.644 558.347 354.623C558.818 354.513 559.299 354.415 559.78 354.338C559.955 354.295 560.119 354.251 560.293 354.24C560.993 354.098 561.693 353.988 562.404 353.868C563.792 353.66 565.213 353.486 566.635 353.354C566.996 353.322 567.334 353.278 567.706 353.267C568.034 353.223 568.384 353.212 568.734 353.179C569.117 353.158 569.466 353.125 569.86 353.114C570.199 353.103 570.549 353.07 570.888 353.059C571.238 353.059 571.577 353.048 571.926 353.026C572.637 353.004 573.359 353.004 574.08 353.004H481.673Z",
    fill: "url(#paint95_linear_1962_309)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M718.996 448.705C724.277 448.705 729.175 450.225 733.286 452.838C738.796 456.326 742.918 461.792 744.667 468.254C745.29 470.506 745.618 472.867 745.618 475.317V644.005C745.618 648.039 744.722 651.866 743.148 655.299C741.026 659.858 737.67 663.717 733.505 666.44C729.328 669.162 724.353 670.736 718.996 670.736C696.386 670.736 680.38 692.843 687.465 714.327L687.946 715.781C687.946 715.781 687.957 715.814 687.99 715.879C688.011 715.912 688.022 715.945 688.044 716C688.088 716.076 688.132 716.175 688.197 716.295C688.318 716.535 688.493 716.863 688.722 717.268C688.777 717.366 688.842 717.476 688.908 717.596C689.039 717.836 689.203 718.099 689.378 718.394C689.433 718.503 689.498 718.602 689.575 718.711C689.673 718.875 689.783 719.05 689.903 719.225C690.012 719.4 690.133 719.586 690.253 719.772C690.668 720.395 691.138 721.084 691.685 721.805C691.937 722.166 692.221 722.538 692.527 722.909C692.888 723.39 693.292 723.872 693.708 724.374C693.904 724.604 694.101 724.834 694.309 725.063C694.943 725.807 695.643 726.572 696.419 727.348C697.983 728.955 699.797 730.617 701.875 732.257C702.4 732.673 702.957 733.099 703.526 733.515C704.029 733.886 704.542 734.247 705.067 734.597C705.526 734.914 705.986 735.231 706.467 735.537C706.696 735.679 706.926 735.832 707.155 735.975C708.457 736.795 709.845 737.593 711.31 738.347C711.649 738.522 711.988 738.697 712.338 738.872C712.71 739.058 713.081 739.244 713.453 739.419C713.836 739.604 714.218 739.779 714.612 739.943C714.995 740.118 715.388 740.293 715.793 740.457C716.186 740.632 716.591 740.796 717.006 740.96C717.411 741.124 717.826 741.288 718.253 741.441C718.559 741.561 718.865 741.682 719.182 741.791C719.729 741.988 720.275 742.174 720.833 742.36C722.036 742.764 723.271 743.136 724.55 743.475C727.032 744.153 729.656 744.721 732.444 745.158H732.466C732.488 745.158 732.521 745.169 732.542 745.169C732.575 745.18 732.597 745.18 732.63 745.191C732.805 745.213 732.969 745.235 733.144 745.246C733.745 745.322 734.346 745.399 734.948 745.454C735.789 745.629 736.697 745.607 737.561 745.727C737.921 745.749 738.282 745.793 738.643 745.836C738.698 745.836 738.741 745.847 738.796 745.858C739.091 745.891 739.387 745.935 739.682 745.978C739.704 745.989 739.736 745.989 739.758 745.989C741.639 746.121 743.596 746.197 745.618 746.208H762.652C802.701 746.208 835.183 714.666 836.921 675.077V523.051C836.921 484.424 807.73 452.838 770.12 449.077C769.518 449.022 768.917 448.968 768.316 448.924C766.446 448.771 764.555 448.705 762.652 448.705H718.996Z",
    fill: "url(#paint96_linear_1962_309)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M574.077 353.004C573.356 353.004 572.634 353.003 571.923 353.025C571.574 353.047 571.235 353.058 570.885 353.058C570.546 353.069 570.196 353.102 569.857 353.113C569.463 353.124 569.114 353.157 568.731 353.178C568.381 353.211 568.031 353.222 567.703 353.266C567.331 353.277 566.993 353.321 566.632 353.353C565.21 353.485 563.789 353.659 562.401 353.867C561.69 353.987 560.99 354.097 560.291 354.239C560.116 354.25 559.952 354.294 559.777 354.337C559.296 354.414 558.815 354.512 558.344 354.622C558.126 354.643 557.907 354.687 557.688 354.742C557.032 354.895 556.376 355.048 555.72 355.212H555.71C555.185 355.332 554.671 355.474 554.179 355.606C553.654 355.748 553.151 355.879 552.659 356.032H552.648C552.145 356.174 551.642 356.327 551.139 356.491C550.145 356.786 549.161 357.136 548.177 357.475C548.144 357.475 548.122 357.486 548.1 357.497C547.16 357.847 546.198 358.219 545.257 358.59C544.776 358.787 544.306 358.984 543.825 359.192C543.344 359.399 542.885 359.607 542.404 359.826C541.923 360.044 541.464 360.263 541.004 360.482C539.605 361.149 538.227 361.848 536.894 362.603C533.756 364.352 530.76 366.309 527.917 368.474C527.546 368.758 527.185 369.042 526.824 369.327C526.638 369.48 526.452 369.622 526.266 369.786C526.004 369.994 525.731 370.212 525.468 370.442C525.086 370.759 524.714 371.065 524.342 371.382C524.277 371.426 524.222 371.481 524.156 371.546C523.839 371.82 523.522 372.104 523.205 372.377C522.341 373.142 521.511 373.93 520.691 374.739C520.275 375.154 519.838 375.581 519.422 376.007C519.018 376.433 518.602 376.871 518.209 377.319C517.87 377.669 517.553 378.019 517.247 378.368C517.094 378.532 516.951 378.707 516.809 378.871C516.481 379.254 516.142 379.637 515.814 380.019C515.497 380.413 515.169 380.807 514.852 381.2C514.688 381.397 514.535 381.594 514.371 381.802C514.218 382.009 514.054 382.206 513.912 382.403C513.606 382.785 513.311 383.19 513.015 383.584C512.491 384.283 511.977 385.005 511.474 385.727C511.168 386.208 510.84 386.689 510.523 387.181C510.173 387.694 509.856 388.208 509.528 388.744C509.2 389.258 508.905 389.772 508.598 390.286C507.363 392.385 506.259 394.55 505.231 396.769C505.001 397.294 504.772 397.83 504.531 398.365C504.302 398.912 504.061 399.48 503.832 400.038C503.613 400.563 503.427 401.099 503.219 401.612C503.186 401.711 503.154 401.798 503.121 401.886C502.99 402.257 502.858 402.651 502.727 403.034C502.093 404.805 501.547 406.598 501.055 408.424C500.978 408.708 500.901 409.003 500.836 409.298C500.727 409.714 500.628 410.118 500.541 410.523C500.431 411.004 500.322 411.485 500.213 411.966C500.114 412.447 500.016 412.928 499.928 413.42L499.83 413.945L499.721 414.459C499.622 415.082 499.513 415.705 499.425 416.339C499.327 416.974 499.251 417.608 499.174 418.231C499.108 418.723 499.043 419.204 498.988 419.685V419.783C498.955 420.079 498.923 420.385 498.901 420.691C498.868 420.997 498.846 421.303 498.824 421.609C498.769 422.243 498.737 422.888 498.704 423.512C498.682 423.96 498.66 424.397 498.649 424.835C498.638 425.119 498.627 425.425 498.627 425.72C498.605 426.256 498.605 426.792 498.605 427.349V448.702V468.513C499.535 464.959 501.186 461.69 503.383 458.891C508.249 452.681 515.814 448.702 524.342 448.702H762.653C763.232 448.702 763.812 448.713 764.391 448.724C764.511 448.724 764.632 448.724 764.741 448.734C765.299 448.745 765.856 448.767 766.414 448.8C767.048 448.833 767.682 448.866 768.316 448.92C768.95 448.964 769.574 449.019 770.197 449.084C770.251 449.095 770.306 449.095 770.361 449.106C770.875 449.15 771.388 449.216 771.902 449.27C771.979 449.281 772.066 449.292 772.143 449.303C772.657 449.369 773.171 449.445 773.673 449.522C773.761 449.533 773.837 449.544 773.925 449.554C774.428 449.631 774.931 449.718 775.434 449.806C775.543 449.817 775.652 449.839 775.762 449.861C775.948 449.893 776.133 449.926 776.319 449.97C776.53 450.002 776.737 450.049 776.946 450.089C777.187 450.135 777.428 450.18 777.67 450.228C778.253 450.345 778.828 450.468 779.402 450.604C779.862 450.702 780.321 450.812 780.78 450.932C780.922 450.965 781.053 450.998 781.196 451.03C781.861 451.2 782.516 451.391 783.174 451.578C783.251 451.601 783.329 451.62 783.404 451.643C783.819 451.752 784.224 451.883 784.628 452.003C784.787 452.05 784.942 452.104 785.101 452.154C785.405 452.249 785.708 452.348 786.01 452.447C786.445 452.592 786.884 452.735 787.307 452.889C787.832 453.075 788.357 453.261 788.871 453.458C788.914 453.469 788.958 453.49 789.002 453.501C789.516 453.698 790.03 453.895 790.543 454.114C790.915 454.256 791.287 454.409 791.659 454.573C792.041 454.726 792.413 454.89 792.785 455.065C793.758 455.48 794.709 455.928 795.649 456.41C796.032 456.584 796.414 456.781 796.797 456.989C797.311 457.24 797.814 457.514 798.317 457.787C798.82 458.06 799.312 458.345 799.804 458.629C803.259 460.619 806.539 462.893 809.611 465.397C809.939 465.659 810.267 465.932 810.595 466.217C810.824 466.402 811.043 466.599 811.273 466.796C811.721 467.179 812.158 467.561 812.585 467.955C813.055 468.381 813.525 468.819 813.984 469.256C814.345 469.606 814.706 469.956 815.056 470.306C815.58 470.819 816.094 471.344 816.597 471.891C816.914 472.219 817.231 472.558 817.537 472.897C817.603 472.962 817.669 473.028 817.723 473.105C818.073 473.487 818.423 473.881 818.751 474.274C819.407 475.007 820.03 475.761 820.642 476.527C820.916 476.866 821.178 477.204 821.441 477.543C824.917 482.026 827.88 486.924 830.253 492.15C830.417 492.511 830.581 492.872 830.734 493.233C831.521 495.026 832.232 496.851 832.877 498.721C832.986 499.027 833.084 499.333 833.183 499.65C833.303 500 833.412 500.35 833.522 500.7C833.653 501.093 833.773 501.487 833.883 501.892C834.014 502.318 834.134 502.755 834.254 503.193C834.375 503.597 834.484 504.013 834.582 504.428C834.735 505.008 834.877 505.598 835.009 506.188C835.02 506.21 835.031 506.232 835.031 506.265C835.173 506.855 835.293 507.435 835.413 508.036C835.533 508.637 835.654 509.25 835.763 509.862C835.85 510.321 835.927 510.791 835.993 511.261C836.058 511.644 836.124 512.038 836.178 512.431C836.244 512.945 836.321 513.47 836.375 513.995C836.736 516.958 836.922 519.986 836.922 523.047V675.073C836.977 673.947 836.998 672.832 836.998 671.706V427.349C836.998 386.175 803.827 353.004 762.653 353.004H574.077Z",
    fill: "url(#paint97_linear_1962_309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1962_309",
    x1: 406.211,
    y1: 597.672,
    x2: 406.234,
    y2: 597.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1962_309",
    x1: 406.244,
    y1: 599.192,
    x2: 406.289,
    y2: 599.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1962_309",
    x1: 406.408,
    y1: 602.217,
    x2: 406.521,
    y2: 602.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1962_309",
    x1: 407.35,
    y1: 609.66,
    x2: 407.587,
    y2: 609.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1962_309",
    x1: 407.465,
    y1: 610.287,
    x2: 407.703,
    y2: 610.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1962_309",
    x1: 407.622,
    y1: 612.82,
    x2: 409.639,
    y2: 612.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1962_309",
    x1: 410.556,
    y1: 622.382,
    x2: 412.165,
    y2: 622.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1962_309",
    x1: 411.362,
    y1: 625.411,
    x2: 414.919,
    y2: 625.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1962_309",
    x1: 413.036,
    y1: 627.867,
    x2: 413.919,
    y2: 627.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1962_309",
    x1: 689.699,
    y1: 719.163,
    x2: 690.424,
    y2: 719.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1962_309",
    x1: 691.953,
    y1: 722.258,
    x2: 692.248,
    y2: 722.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1962_309",
    x1: 692.121,
    y1: 722.936,
    x2: 694.025,
    y2: 722.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1962_309",
    x1: 693.723,
    y1: 724.603,
    x2: 694.539,
    y2: 724.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1962_309",
    x1: 694.834,
    y1: 726.112,
    x2: 696.692,
    y2: 726.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1962_309",
    x1: 698.967,
    y1: 729.894,
    x2: 699.443,
    y2: 729.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1962_309",
    x1: 704.979,
    y1: 734.722,
    x2: 706.157,
    y2: 734.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1962_309",
    x1: 709.442,
    y1: 737.668,
    x2: 712.161,
    y2: 737.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1962_309",
    x1: 713.514,
    y1: 739.81,
    x2: 717.139,
    y2: 739.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1962_309",
    x1: 715.323,
    y1: 740.92,
    x2: 722.732,
    y2: 740.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1962_309",
    x1: 720.897,
    y1: 742.649,
    x2: 724.681,
    y2: 742.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1962_309",
    x1: 732.514,
    y1: 745.171,
    x2: 732.65,
    y2: 745.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1962_309",
    x1: 732.813,
    y1: 745.577,
    x2: 747.541,
    y2: 745.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1962_309",
    x1: 740.105,
    y1: 746.079,
    x2: 741.895,
    y2: 746.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1962_309",
    x1: 739.756,
    y1: 746.094,
    x2: 746.202,
    y2: 746.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1962_309",
    x1: 732.633,
    y1: 745.587,
    x2: 739.757,
    y2: 745.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1962_309",
    x1: 500.024,
    y1: 411.919,
    x2: 500.024,
    y2: 413.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1962_309",
    x1: 502.139,
    y1: 401.443,
    x2: 502.139,
    y2: 408.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1962_309",
    x1: 504.533,
    y1: 396.69,
    x2: 504.533,
    y2: 400.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1962_309",
    x1: 510.028,
    y1: 387.142,
    x2: 510.028,
    y2: 388.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1962_309",
    x1: 515.095,
    y1: 379.978,
    x2: 515.095,
    y2: 381.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1962_309",
    x1: 516.532,
    y1: 378.329,
    x2: 516.532,
    y2: 380.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1962_309",
    x1: 525.306,
    y1: 369.746,
    x2: 525.306,
    y2: 371.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1962_309",
    x1: 510.353,
    y1: 642.343,
    x2: 510.353,
    y2: 670.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1962_309",
    x1: 406.211,
    y1: 597.672,
    x2: 406.234,
    y2: 597.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1962_309",
    x1: 406.244,
    y1: 599.192,
    x2: 406.289,
    y2: 599.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1962_309",
    x1: 406.408,
    y1: 602.217,
    x2: 406.521,
    y2: 602.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1962_309",
    x1: 407.35,
    y1: 609.66,
    x2: 407.587,
    y2: 609.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1962_309",
    x1: 407.465,
    y1: 610.287,
    x2: 407.703,
    y2: 610.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1962_309",
    x1: 407.622,
    y1: 612.82,
    x2: 409.639,
    y2: 612.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1962_309",
    x1: 410.556,
    y1: 622.382,
    x2: 412.165,
    y2: 622.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1962_309",
    x1: 411.362,
    y1: 625.411,
    x2: 414.919,
    y2: 625.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1962_309",
    x1: 413.036,
    y1: 627.867,
    x2: 413.919,
    y2: 627.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1962_309",
    x1: 689.699,
    y1: 719.163,
    x2: 690.424,
    y2: 719.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1962_309",
    x1: 691.953,
    y1: 722.258,
    x2: 692.248,
    y2: 722.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1962_309",
    x1: 692.121,
    y1: 722.936,
    x2: 694.025,
    y2: 722.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1962_309",
    x1: 693.723,
    y1: 724.603,
    x2: 694.539,
    y2: 724.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1962_309",
    x1: 694.834,
    y1: 726.112,
    x2: 696.692,
    y2: 726.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1962_309",
    x1: 698.967,
    y1: 729.894,
    x2: 699.443,
    y2: 729.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1962_309",
    x1: 704.979,
    y1: 734.722,
    x2: 706.157,
    y2: 734.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1962_309",
    x1: 709.442,
    y1: 737.668,
    x2: 712.161,
    y2: 737.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1962_309",
    x1: 713.514,
    y1: 739.81,
    x2: 717.139,
    y2: 739.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1962_309",
    x1: 715.323,
    y1: 740.92,
    x2: 722.732,
    y2: 740.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1962_309",
    x1: 720.897,
    y1: 742.649,
    x2: 724.681,
    y2: 742.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1962_309",
    x1: 732.514,
    y1: 745.171,
    x2: 732.65,
    y2: 745.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1962_309",
    x1: 732.813,
    y1: 745.577,
    x2: 747.541,
    y2: 745.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1962_309",
    x1: 740.105,
    y1: 746.079,
    x2: 741.895,
    y2: 746.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1962_309",
    x1: 739.76,
    y1: 746.099,
    x2: 745.62,
    y2: 746.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1962_309",
    x1: 732.633,
    y1: 745.583,
    x2: 739.685,
    y2: 745.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1962_309",
    x1: 523.435,
    y1: 458.829,
    x2: 499.06,
    y2: 458.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1962_309",
    x1: 406.211,
    y1: 597.672,
    x2: 406.222,
    y2: 597.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1962_309",
    x1: 406.243,
    y1: 599.192,
    x2: 406.265,
    y2: 599.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1962_309",
    x1: 406.406,
    y1: 602.217,
    x2: 406.461,
    y2: 602.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1962_309",
    x1: 407.346,
    y1: 609.66,
    x2: 407.46,
    y2: 609.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1962_309",
    x1: 407.461,
    y1: 610.287,
    x2: 407.576,
    y2: 610.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1962_309",
    x1: 407.577,
    y1: 612.859,
    x2: 408.605,
    y2: 612.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1962_309",
    x1: 409.774,
    y1: 620.124,
    x2: 410.452,
    y2: 620.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1962_309",
    x1: 410.454,
    y1: 622.267,
    x2: 411.307,
    y2: 622.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1962_309",
    x1: 411.305,
    y1: 625.411,
    x2: 413.021,
    y2: 625.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1962_309",
    x1: 413.022,
    y1: 627.743,
    x2: 413.328,
    y2: 627.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1962_309",
    x1: 414.574,
    y1: 631.083,
    x2: 415.132,
    y2: 631.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1962_309",
    x1: 688.122,
    y1: 716.178,
    x2: 688.144,
    y2: 716.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1962_309",
    x1: 689.688,
    y1: 719.129,
    x2: 689.994,
    y2: 719.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1962_309",
    x1: 691.992,
    y1: 722.29,
    x2: 692.091,
    y2: 722.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1962_309",
    x1: 692.486,
    y1: 723.192,
    x2: 693.011,
    y2: 723.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1962_309",
    x1: 694.804,
    y1: 725.812,
    x2: 695.143,
    y2: 725.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1962_309",
    x1: 695.315,
    y1: 726.396,
    x2: 695.698,
    y2: 726.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1962_309",
    x1: 698.959,
    y1: 729.991,
    x2: 699.407,
    y2: 729.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1962_309",
    x1: 703.527,
    y1: 734.213,
    x2: 705.528,
    y2: 734.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1962_309",
    x1: 713.456,
    y1: 739.727,
    x2: 714.823,
    y2: 739.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1962_309",
    x1: 715.204,
    y1: 740.92,
    x2: 718.779,
    y2: 740.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1962_309",
    x1: 720.836,
    y1: 742.649,
    x2: 722.662,
    y2: 742.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1962_309",
    x1: 732.512,
    y1: 745.171,
    x2: 732.577,
    y2: 745.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1962_309",
    x1: 737.923,
    y1: 745.905,
    x2: 739.683,
    y2: 745.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1962_309",
    x1: 740.076,
    y1: 746.057,
    x2: 740.492,
    y2: 746.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1962_309",
    x1: 740.494,
    y1: 746.106,
    x2: 740.942,
    y2: 746.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1962_309",
    x1: 694.381,
    y1: 726.204,
    x2: 698.754,
    y2: 726.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1962_309",
    x1: 732.782,
    y1: 745.572,
    x2: 747.577,
    y2: 745.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1962_309",
    x1: 739.76,
    y1: 746.099,
    x2: 745.62,
    y2: 746.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1962_309",
    x1: 732.633,
    y1: 745.583,
    x2: 739.685,
    y2: 745.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1962_309",
    x1: 590.903,
    y1: 454.582,
    x2: -82.8599,
    y2: 854.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B678F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125871,
    stopColor: "#B678F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736424,
    stopColor: "#7B13FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#400A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1962_309",
    x1: 620.602,
    y1: 504.563,
    x2: -53.1609,
    y2: 904.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B678F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125871,
    stopColor: "#B678F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736424,
    stopColor: "#7B13FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#400A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1962_309",
    x1: 533.86,
    y1: 203.163,
    x2: 533.86,
    y2: 524.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B678F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125871,
    stopColor: "#B678F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736424,
    stopColor: "#7B13FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#400A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1962_309",
    x1: 259.516,
    y1: 592.827,
    x2: 266.665,
    y2: 299.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B678F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125871,
    stopColor: "#B678F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736424,
    stopColor: "#7B13FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#400A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1962_309",
    x1: 185.443,
    y1: 363.184,
    x2: 523.813,
    y2: 367.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B678F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125871,
    stopColor: "#B678F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736424,
    stopColor: "#7B13FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#400A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1962_309",
    x1: 409.118,
    y1: 612.715,
    x2: 1010.8,
    y2: 1029.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1962_309",
    x1: 490.141,
    y1: 352.138,
    x2: 490.141,
    y2: 673.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1962_309",
    x1: 764.482,
    y1: 741.806,
    x2: 757.334,
    y2: 448.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1962_309",
    x1: 838.556,
    y1: 512.157,
    x2: 500.186,
    y2: 516.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124832,
    stopColor: "#1ED8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730343,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01438F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.c38d7b5bd146b46a2276292f259278b5.svg";
export { ForwardRef as ReactComponent };